import React, {Component} from 'react';
import {Sidebar} from 'primereact/sidebar';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import circleToPolygon from 'circle-to-polygon';
import html2canvas from 'html2canvas';
import md5 from 'md5';
import MouseTooltip from 'react-sticky-mouse-tooltip';
import percentile from 'percentile';

// 🎨 Estilos
import './mapa.css';

// ⚙️ Configs
import configSociodemografia from './SocioDemografia/config';
import {defaultCircleOptions, defaultPolygonOptions} from './mapsDefaultOptions';

// 🧩 Componentes
import AlertModal from './AlertModal';
import Ferramentas from './Ferramentas/Ferramentas';
import FormFilters from '../components/FormFilters';
import HeatMapLegend from './HeatMapLegend';
import Legenda from './Legenda';
import LegendaDataLayer from '../components/LegendaDatalayer/Legenda';
import LegendaPoloGerador from './LegendaPoloGerador';
import LinkagesDataTableModal from './LinkagesDataModal/LinkagesDataTableModal';
import Loader from './Loader';
import MapCapture from './MapCapture/MapCapture';
import MapWithADrawingManager from './MapWithADrawingManager';
import ModalHeatMap from './ModalHeatMap';
import ModalLegendaRendaIbge from './ModalLegendaRendaIbge/ModalLegendaRendaIbge';
import ModalPolosGeradores from './ModalPolosGeradores';
import ModalRaioPorDeslocamento from './RaioPorDeslocamento/ModalRaioPorDeslocamento';
import ModalRanges from './ModalRanges';
import ModalSalvarProjeto from './Projeto/ModalSalvarProjeto';
import ReloadBuildingsWithoutMetaData from './FuncoesMapaPrimario/ReloadBuildingsWithoutMetaData';
import RendaIbgeLegend from './RendaIbgeLegend';
import ShapesAttributesEditor from './ShapesAttributesEditor/ShapesAttributesEditor';
import SlidingPaneEmpreendimento from './SlidingPanelEmpreendimento';
import SocioDemografiaModal from './SocioDemografia/SocioDemografiaModal';

// 📡 Serviços
import ClusterService from '../services/ClusterService';
import EmpreendimentoService from '../services/empreendimentosServices';
import EmpreendimentoServiceCrawler from '../services/empreendimentosServicesCrawler';
import geolocationService from '../services/geolocationService';
import KmlService from '../services/KmlService';
import LinkagesDataLayerService from '../services/LinkagesDataLayer/LinkagesDataLayerService';
import formater from "../services/LinkagesDataLayer/formater";
import getLabel from '../services/LinkagesDataLayer/labels';
import PolosGeradoresService from '../services/PolosGeradoresService';
import {
    getDomiciliosPorFaixaDeRenda,
    getDomiciliosPorNumeroMoradores,
    getDomiciliosPorNumeroMoradores2022,
    getDomiciliosPorTipo,
    getDomiciliosPorTipo2022,
    getFaixasEtarias,
    getFaixasEtarias2022,
    getPopulacaoPorFaixaDeRenda,
    getSetoresWithHouldhouseIncome,
    getSetoresWithPopulationDensity,
    getSetoresWithPopulationDensityCenso2022,
    getSetoresWithPropertyIndex,
    getSetoresWithVerticalizationIndex,
    getSetoresWithVerticalizationIndex2022,
    initializeColors
} from '../services/rendaIbgeService';
import SimpleEmpreendimentosService from '../services/SimpleEmpreendimentosService';
import ZoneamentoService from '../services/ZoneamentoService';

// 🛠 Utils & Helpers
import colors, {getRandomColor, polosGeradoresColor} from '../util/colors';
import {convertPolygonToGeojson, getPolygonPath} from '../util/geoUtil';
import {empreendimentoInfoWindow, poloInfoWindow} from '../util/empreendimentoInfoWindow';
import getBrowserGeolocation from '../util/geolocation';
import {slugify} from '../util/helpers';
import {padroesHorizontais, padroesVerticais} from '../util/padroes';
import {replaceMarkersRevendaLocacao} from '../util/RevendaLocacaoUtil';

class DefaultMap extends Component {

    initialState = {
        empreendimentos: [],
        empreendimentosDoMes: [],
        currentPosition: { lat: -25.551136, lng: -49.1929618 },
        isSlideOpen: false,
        currentShowing: undefined,
        tipo_empreendimento: [],
        check_incluir_monitoradas: false,
        tipo_negocio: [],
        status: ["Comercialização"],
        retrofit: [],
        polygons: [],
        circles: [],
        markers: [],
        markersPolosGeradores: [],
        overlays: [],
        revendaLocacao: [],
        area_maior_que: '',
        area_menor_que: '',
        porcentagem_vendida_minima: '',
        porcentagem_vendida_maxima: '',
        padrao: [],
        panel_empreendimento_visible: true,
        loadingMetadata: false,
        modal_empreendimento_visible: true,
        valor_maior_que: '',
        valor_menor_que: '',
        valor_metro_maior_que: '',
        valor_metro_menor_que: '',
        raio: 3000,
        cidade: [],
        estado: [],
        regiao: [],
        bairros: [],
        pontos: [],
        ano_lancamento: [],
        mes_ano_lancamento: '',
        estagio: [],
        incorporadoras: [],
        loading_empreendimento: false,
        modalHeatMapOpen: false,
        fillColor: 'green',
        selectedIcon: undefined,
        showInfoWindow: false,
        alreadyDisplayed: false,
        showTooltip: false,
        radiusChanging: '',
        countRectangles: 0,
        countPolygons: 0,
        zoom: 15,
        nome_empreendimento: [],
        address: '',
        bairrosOptions: [],
        quartos: [],
        vagas: [],
        juros_maximo: '',
        juros_minimo: '',
        valor_parcela_minima: '',
        valor_parcela_maxima: '',
        parcelas_minimo: '',
        parcelas_maximo: '',
        ranges: [],
        kml_bairros: [],
        kml_layers: [],
        kmls_to_show: [],
        showKMl: false,
        showInfo: false,
        showProjectName: false,
        projeto: '',
        project_name: null,
        project_share_users: [],
        projetos: [],
        heatMap: null,
        show_polos_geradores: false,//mostrar polos geradores
        polos_geradores: [],
        show_modal_polos_geradores: false,
        polos_geradores_types_selected: [],
        showMarkers: true,//mostrar marcadores de empreendimentos
        showResaleMarkers: false,//mostrar marcadores de revenda e locacao
        showResaleOrLocationMarkers: false,//mostrar marcadores de revenda e locacao
        showLocationMarkers: false,//mostrar marcadores de revenda e locacao
        polos_geradores_current_showing: [],
        polos_geradores_current_grouped: [],
        polos_geradores_current_cache_key: '',//chave de cache para os polos geradores, usado para exportar os polos geradores em Excel no Backend
        estadosSelecionados: [],
        busca_por_estado: false,
        medianIntensity: 0,
        heatMapConfig: {},
        show_modal_change_shape_attributes: false,
        current_shape_editing: null,
        heatMapLegendConfig: [],
        use_cluster: false,
        showRenda: false,
        rendas_por_area: [],
        faixa_etaria_data: [],
        loading_dados_socio_demografia: false,
        show_modal_dados_socio_demografia: false,
        dados_senso_demografico: {},
        show_modal_raio_de_deslocamento: false,
        left_side_bar_visible: true,
        active_tab: 'filtros',
        loadingSaveProject: false,
        errors_projeto: [],
        setoresColorRanges: [
            { min: 0, max: 1000, color: '#a1d070' },
            { min: 1001, max: 2000, color: '#ffff00' },
            { min: 2001, max: 3000, color: '#80ff00' },
            { min: 3001, max: 4000, color: '#00ff00' },
            { min: 4001, max: 5000, color: '#00ff80' },
            { min: 5001, max: 6000, color: '#ff7000' },
            { min: 6001, max: 7000, color: '#00ffff' },
            { min: 7001, max: 8000, color: '#0080ff' },
            { min: 8001, max: 9000, color: '#0000ff' },
            { min: 9001, max: 10000, color: '#8000ff' },
            { min: 10001, max: 11000, color: '#ff00ff' },
            { min: 11001, max: 12000, color: '#ff0080' },
            { min: 12001, max: 13000, color: '#FFC0CB' },
            { min: 13001, max: 14000, color: '#008080' },
            { min: 14001, max: 15000, color: '#800000' },
            { min: 15001, max: Infinity, color: '#556B2F' }
        ],
        show_modal_customizar_cores_setores: false,
        mapa_coropetico_current_showing: null,
        color_ranges: {},

        buscaEmpreendimentossDefaultOptions: [],
        inputEstadoValue: "",
        inputBairroValue: "",
        zoneamentoDisponivel: false,
        show_zoneamento: false,
        geojson_zoneamento: {},
        legenda_zoneamento: [],
        valores_propriedades_zoneamento: {},
        opcoes_propriedades_zoneamento: [],
        opcoes_clustes: [],
        cluster: '',
        mapScreenCaptureData: null,
        mapScreenCanvasBlob: null,
        mapScreenCanvasPDF: null,
        show_modal_map_screen_capture: false,
        hide_search_box: false,
        canvas: null,
        datalayer: null,
        datalayers: [],
        show_modal_data_layer: false,
        datalayerName: null,
        datalayerFriendlyName: null,
        datalayerYear: null,
        datalayerYears: [],
        datalayer_data: [],
        datalayer_columns: [],
        modalRangesOpen: false,
        datalayerColorProperty: null,
        datalayerColorPropertyOptions: [],
        showLegendaRenda: false,
        datalayers_data_cache: {},
        datalayerYearOptions: {},
        show_demarcacao_areas: false,
        show_modal_datalayer_datatable: false,
        datalayers_table_data: [],
        colorsOptions: [
            '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'

        ],
        datalayerFillOpacity: 0.3,
        isDrawing: false
    }

    constructor(props) {
        super(props);
        this.clusterService = new ClusterService();
        this.state = this.initialState;
    }

    infoWindow = null;
    mapClickListenerAdded = false;
    markers = [];
    markersClusterer = null;
    markersPolosGeradores = [];
    markersClustererPolosGeradores = null;

    toggleShowMarkers = () => { this.setState({ showMarkers: !this.state.showMarkers }) }

    setDemarcacaoAreas = async (value) => {
        await this.setState({
            ...this.state,
            show_demarcacao_areas: value,
            loading: true
        });

        setTimeout(async () => {
            await this.setDatalayerStyle(this.state.datalayer, this.state.datalayerName);
            await this.setState({
                ...this.state,
                loading: false
            });
        }, 1);
    }


    editShapeName = (shape) => {
        this.setState({
            show_modal_change_shape_attributes: !this.state.show_modal_change_shape_attributes,
            current_shape_editing: shape
        })

        if ($('#results-icon').hasClass('fa-angle-double-right')) {
            $("#btn-results").click();
        }

    }

    updateRendaColorRange = (colorRange, index) => {
        let keyColorRange = this.getColorRangeKey();
        let colorRanges = this.state.color_ranges[keyColorRange];

        //se index for -1 adiciona no final do array (Caso de quando está sendo adicionado um novo range)
        if (index === -1) {
            colorRanges.push(colorRange);
        } else {
            colorRanges[index] = colorRange;
        }

        this.setState({
            color_ranges: {
                ...this.state.color_ranges,
                [keyColorRange]: [...colorRanges]
            }
        });
    }

    replaceColorRanges = (colorRanges) => {

        let keyColorRange = this.getColorRangeKey();

        this.setState({
            ...this.state,
            color_ranges: {
                ...this.state.color_ranges,
               [keyColorRange]: [...colorRanges]
           }
        });
    }

    removeRendaColorRange = (index) => {

        let keyColorRange = this.getColorRangeKey();

        let colorRanges = this.state.color_ranges[keyColorRange];

        colorRanges.splice(index, 1);

        this.setState({
            color_ranges: {
                ...this.state.color_ranges,
                [keyColorRange]: [...colorRanges]
            }
        });
    }

    setShapeName = async (name) => {
        let shape = this.state.current_shape_editing;

        shape.name = name;

        await this.setState({ current_shape_editing: shape });
    }

    updateShape = async (shape) => {

        let circles = this.state.circles;
        let overlays = this.state.overlays;

        for (let i = 0; i < overlays.length; i++) {
            if (overlays[i].id === shape.id) {
                overlays[i] = shape;
                overlays[i].color = shape.fillColor === "transparent" ? shape.strokeColor : shape.fillColor;
            }
        }

        if (shape.type === 'Círculo') {
            for (let i = 0; i < circles.length; i++) {
                if (circles[i].id === shape.id) {
                    circles[i] = shape;
                    circles[i].color = shape.fillColor === "transparent" ? shape.strokeColor : shape.fillColor;
                }
            }
        }

        await this.setState({
            overlays: [...overlays],
            circles: [...circles],
            show_modal_change_shape_attributes: !this.state.show_modal_change_shape_attributes,
            current_shape_editing: null
        });

        if ($('#btn-results').hasClass('fa-angle-double-right')) {
            $("#btn-results").click();

        }
    }

    //carrega kmls de bairros
    loadKml = async () => {
        try {

            let cidadesComKmlBairros = this.state.kml_bairros;

            if (cidadesComKmlBairros.length === 0) {
                return;
            }

            let kmls_to_show = [];
            for (let i = 0; i < cidadesComKmlBairros.length; i++) {
                let kmlFile = this.state.kml_bairros[i];
                kmls_to_show.push(kmlFile.kml);

            }

            await this.setState({
                kmls_to_show: [...kmls_to_show],
            });

        } catch (e) {
            console.log(e);
        }
    }

    openModalLegendaSetores = async () => {
        await this.setState({
            show_modal_customizar_cores_setores: true,
            left_side_bar_visible: false
        });

        if ($('#results-icon').hasClass('fa-angle-double-right')) {
            $("#btn-results").click();
        }
    }

    closeModalLegendaSetores = async () => {
        await this.setState({ show_modal_customizar_cores_setores: false });
    }

    formatInfoWindowDatum = (type, value) => {

        let formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        let doubleFormatter = new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            maximumFractionDigits: 2
        });


        if (type === 'currency') {
            return formatter.format(value);
        }

        if (type === 'percentage') {
            return formatter.format(value).replace("R$", "") + '%';
        }

        if (type === 'integer') {
            return new Intl.NumberFormat('pt-BR').format(value);
        }

        if (type === 'double') {
            return doubleFormatter.format(value);
        }


        if (type === 'km2') {
            let formatter = new Intl.NumberFormat('pt-BR', {
                style: 'decimal',
                maximumFractionDigits: 6
            });

            return formatter.format(value);
        }


        return value;

    }


    showIbgeInfo = async (tipoInfo, data) => {

        let configOptions = configSociodemografia[tipoInfo];

        await this.removeIbgeDataLayer();
        await this.removeZoneamentoDataLayer();

        await this.setState({
            showRenda: false,
            datalayerName: tipoInfo,
            datalayerFriendlyName: configOptions.title,
            showLegendaRendaIbge: true,
            show_zoneamento: false,
            loading: true,
            showLegendaRenda: true
        });

        try {
            let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

            let dataLayer = new google.maps.Data();
            dataLayer.addGeoJson(data.geojson)
            dataLayer.setMap(map);
            window.ibge_layer = dataLayer;

            dataLayer.setStyle(function (feature) {

                return {
                    fillColor: feature.getProperty("color"),
                    fillOpacity: 0.9,
                    strokeWeight: 1,
                    strokeColor: '#000000',
                    strokeOpacity: 0.5
                };
            });


            dataLayer.addListener('click', (event) => {
                let feature = event.feature;

                let body = '';

                for (let i = 0; i < configOptions.dados_info_window.length; i++) {
                    let datum = configOptions.dados_info_window[i];
                    let value = feature.getProperty(datum.field);

                    let formattedValue = this.formatInfoWindowDatum(datum.type, value);

                    body += `
                        <div class="info-window-item">
                            <span class="info-window-item-label">${datum.label}:</span>
                            <span class="info-window-item-value">${formattedValue}</span>
                        </div>
                    `;
                }

                let content = `
                    <div class="info-window">
                        <div class="info-window-header">
                            <h5 class="info-window-title">Setor Censitário</h5>
                            <h6 class="info-window-subtitle">${feature.getProperty('codigo_setor')}</h6>
                        </div>
                        <div class="info-window-body">
                          ${body}
                        </div>
                    </div>
                `;

                if (!this.infoWindow) {
                    this.infoWindow = new google.maps.InfoWindow();
                }
                this.infoWindow.setContent(content);
                this.infoWindow.setPosition(event.latLng);
                this.infoWindow.open(map);


            });


            await this.setState({
                ...this.state,
                ibge_info: data,
                showRenda: true,
                ibgeDataLayer: dataLayer,
                left_side_bar_visible: true,
                active_tab: 'legendas',
                setoresColorRanges: configOptions.color_ranges
            });

        } catch (error) {
            console.log(error);
        } finally {
            await this.setState({
                ...this.state,
                loading: false
            });
        }


    }

    getZoneamento = async () => {

        const zoneamentoService = new ZoneamentoService();
        const estado = this.state.cidade[0].value.split('-')[0];

        const slugCidade = slugify(this.state.cidade[0].label);
        if (this.state.geojson_zoneamento[slugCidade]) {
            return this.state.geojson_zoneamento[slugCidade]
        }

        const zoneamentoDataResponse = await zoneamentoService.getZoneamento({
            cidade: this.state.cidade[0].label,
            estado: estado
        });

        if (zoneamentoDataResponse.status === 200) {
            return zoneamentoService.prepareData(zoneamentoDataResponse.data)
        }

        return null;
    }

    handleFiltrarZoneamento = async ({ property, value }) => {
        const slugCidade = slugify(this.state.cidade[0].label);

        let geojson = this.state.geojson_zoneamento[slugCidade].geojson;

        for (let feature of geojson.features) {
            feature.properties.visible = feature.properties[property] === value;
        }

        await this.setState({
            ...this.state,
            geojson_zoneamento: {
                [slugCidade]: {
                    ...this.state.geojson_zoneamento[slugCidade],
                    geojson
                }
            }
        })

        await this.showZoneamentoLayer();
    }


    showZoneamentoLayer = async () => {
        try {
            this.setState({
                ...this.state,
                loading: true
            });

            await this.removeIbgeDataLayer();
            await this.removeZoneamentoDataLayer();

            let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

            const { legenda, geojson, valoresPropriedades, opcoesDropdownProperties } = await this.getZoneamento();

            if (geojson) {

                let zoneamentoDataLayer = new google.maps.Data();
                zoneamentoDataLayer.addGeoJson(geojson)
                zoneamentoDataLayer.setMap(map);
                window.zoneamentoDataLayer = zoneamentoDataLayer;

                zoneamentoDataLayer.setStyle(function (feature) {

                    let isVisible = feature.getProperty("visible");

                    let fillColor = feature.getProperty("color");
                    let strokeOpacity = 0.5;
                    let strokeColor = 'blue';
                    let strokeWeight = 1;
                    let fillOpacity = 0.6;

                    return {
                        fillColor: fillColor,
                        fillOpacity: fillOpacity,
                        strokeWeight: strokeWeight,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        visible: isVisible
                    };
                });

                const zoneamentoService = new ZoneamentoService();

                zoneamentoDataLayer.addListener('click', (event) => {
                    let feature = event.feature;
                    this.infoWindow?.close();

                    let propertiesLabels = zoneamentoService.properties;

                    let body = '';

                    for (let key in propertiesLabels) {
                        let label = propertiesLabels[key];
                        let value = feature.getProperty(key);

                        /*if( value === null ){
                            continue;
                        }*/

                        body += `
                        <div class="info-window-item">
                            <span class="info-window-item-label font-weight-bold">${label}:</span>
                            <span class="info-window-item-value">${value}</span>
                        </div>
                    `;
                    }

                    let content = `
                    <div class="info-window">
                        <div class="info-window-header">
                            <h5 class="info-window-title">SIGLA ZONEAMENTO</h5>
                            <h6 class="info-window-subtitle">${feature.getProperty('sigla_zoneamento')}</h6>
                        </div>
                        <div class="info-window-body" style="max-height:400px;overflow-y:auto;">
                          ${body}
                        </div>
                    </div>
                `;

                    let infoWindow = new google.maps.InfoWindow({
                        content: content
                    });

                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map);

                    this.infoWindow = infoWindow;

                });

                const slugCidade = slugify(this.state.cidade[0].label);

                await this.setState({
                    ...this.state,
                    zoneamentoDataLayer: zoneamentoDataLayer,
                    legenda_zoneamento: legenda,
                    valores_propriedades_zoneamento: valoresPropriedades,
                    opcoes_propriedades_zoneamento: opcoesDropdownProperties,
                    geojson_zoneamento: {
                        ...this.state.geojson_zoneamento,
                        [slugCidade]: {
                            legenda,
                            geojson,
                            valoresPropriedades,
                            opcoesDropdownProperties
                        }
                    },
                    show_zoneamento: true
                })

            }
        } catch (error) {
            console.log(error);
        } finally {
            await this.setState({
                ...this.state,
                loading: false
            })
        }
    }

    getOverlayName = (shapeId) => {

        const overlay = this.state.overlays.find(o => o.id === shapeId);

        if (overlay) {
            return `${overlay.type} ${overlay.name}`;
        }

        return '';
    }

    getCachedDataLayerData = (hash) => {
        const cachedData = this.state.datalayers_data_cache?.[hash]?.[this.state.datalayerName];

        if (cachedData) {
            return cachedData;
        }
    }

    putDataOnCache = async (hash, data) => {
        const cachedData = this.state.datalayers_data_cache;

        await this.setState({
            ...this.state,
            datalayers_data_cache: {
                ...cachedData,
                [hash]: {
                    ...cachedData[hash],
                    [this.state.datalayerName]: data
                }
            }
        })

    }

    /**
     * Obtém os dados do datalayer da Linkage via api ou cache
     * @returns {Promise<*>}
     */
    getDatalayerData = async () => {
        try {
            await this.setLoading(true);
            const requestPayload = this.getTransformedPayloadForSenso();

            const cachedData = this.getCachedDataLayerData(requestPayload.hash);

            if (cachedData) {
                return cachedData;
            }

            const response = await LinkagesDataLayerService.getDataLayer(requestPayload);

            if (response.status === 200) {
                await this.putDataOnCache(requestPayload.hash, response.data);
            }

            return response.data;
        } catch (e) {
            console.log(e)
        } finally {
            await this.setLoading(false);
        }
    }

    loadYearsOptionsForLinkagesDataLayer = async () => {
        const response = await LinkagesDataLayerService.getYearsForDataLayer(
            {
                cidades: this.state.cidade.map(c => c.label),
                estados: this.state.estado,
            }
        );

        if (response.status === 200) {

            const datalayerYearOptions = {};
            const keys = Object.keys(response.data);

            for (let i = 0; i < keys.length; i++) {
                const layerName = keys[i];
                const years = response.data[layerName];

                if (years.length > 0) {
                    datalayerYearOptions[layerName] = years.map(year => {
                        return { value: year, label: year.toString() };
                    });
                } else {
                    datalayerYearOptions[layerName] = [];
                }
            }

            await this.setState({
                ...this.state,
                datalayerYearOptions: datalayerYearOptions
            });
        }
    };

    /**
     * Dados agregados do datalayer por cidade e áreas selecionadas
     * @returns {Promise<void>}
     */
    loadDataLayerAggregated = async () => {
        try {
            await this.setLoading(true);

            const requestPayload = this.getTransformedPayloadForSenso();
            requestPayload.field = null;

            const response = await LinkagesDataLayerService.getAggregatedData(requestPayload);

            if (response.status === 200 && response.data.length) {
                this.setState({
                    ...this.state,
                    show_modal_datalayer_datatable: true,
                    datalayers_table_data: response.data,
                    left_side_bar_visible: false
                });

                if ($('#results-icon').hasClass('fa-angle-double-right')) {
                    $("#btn-results").click();
                }
            }


        } catch (e) {
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    closeModalDatalayerTable = async () => {
        this.setState({
            ...this.state,
            show_modal_datalayer_datatable: false
        });
    }


    /**
     * Carregar datalayer da Linkage
     * @returns {Promise<void>}
     */
    loadDataLayer = async () => {

        await this.setLoading(true);

        await this.removeAllDataLayers();

        if (this.state.datalayerName == null) {
            return;
        }

        try {

            const data = await this.getDatalayerData();

            if( data?.features?.length === 0 || data?.features?.length === undefined ){
                toast.warn("Nenhum resultado encontrado para a camada de sociodemografia selecionada.", {
                    position: "top-center",
                    autoClose: 5000,
                });

            }

            let rangeColors = LinkagesDataLayerService.getColorRangerForDatalayerProperty(
                this.state.datalayerName,
                this.state.datalayerColorProperty
            );

            let keyColorRange = this.getColorRangeKey();

            if( this.state.color_ranges[keyColorRange]){
                rangeColors = this.state.color_ranges[keyColorRange];
            }

            const responseData = initializeColors(data, rangeColors, this.state.datalayerColorProperty);

            await this.addGoogleMapsDataLayer(responseData, this.state.datalayerColorProperty);

            if (responseData.length === 0) {
                toast.warn("Nenhum resultado encontrado para a camada de sociodemografia selecionada.", {
                    position: "top-center",
                    autoClose: 5000,
                });
                return;
            }

            this.setState({
                ...this.state,
                datalayer_columns: [],
                left_side_bar_visible: false,
                showLegendaRenda: true,
                color_ranges: {
                    ...this.state.color_ranges,
                    [keyColorRange]: rangeColors
                },
                colorsOptions: LinkagesDataLayerService.getColorsOptions(
                    this.state.datalayerName
                )
            });

            if ($('#results-icon').hasClass('fa-angle-double-right')) {
                $("#btn-results").click();
            }


        } catch (error) {
            console.log(error);
        } finally {
            await this.setLoading(false);
        }

    }

    getColorRangeKey() {
        let keyColorRange = this.state.datalayerName;

        if (this.state.datalayerColorProperty) {
            keyColorRange = `${this.state.datalayerName}_${this.state.datalayerColorProperty}`;
        }
        return keyColorRange;
    }

    setDatalayerStyle = async (datalayer, datalayerName) => {
        return new Promise((resolve, reject) => {

            datalayer.setStyle((feature) => {

                let fillColor = feature.getProperty("color") || getRandomColor();

                let strokeWeight = 1;
                let strokeColor = fillColor;
                let strokeOpacity = 0.1;

                if (this.state.show_demarcacao_areas) {
                    strokeColor = 'black';
                    strokeOpacity = 0.5;
                }

                if (datalayerName === 'dutovias') {
                    strokeWeight = 8;
                    strokeColor = '#8C5824';
                    strokeOpacity = 0.5;
                }

                return {
                    fillColor: fillColor,
                    fillOpacity: this.state.datalayerFillOpacity,
                    strokeWeight: strokeWeight,
                    strokeColor: strokeColor,
                    strokeOpacity: strokeOpacity,
                };
            });

            resolve();

        });
    }

    addDatalayerListener = (datalayer) => {
        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        const ignoreProperties = ['dt_upload', 'gid_uf', 'gid_municipio', 'id', 'color'];

        datalayer.addListener('click', (event) => {

            if (this.infoWindow) {
                this.infoWindow.close();
            }

            let feature = event.feature;

            let body = '';

            feature.forEachProperty((value, label) => {

                if (!ignoreProperties.includes(label) && value !== null && value !== undefined && value !== '') {
                    let friendlyLabel = getLabel(label);
                    let formattedValue = formater(label, value);
                    body += `
                            <div class="info-window-item">
                                <span class="info-window-item-label font-weight-bold">${friendlyLabel}:</span>
                                <span class="info-window-item-value">${formattedValue}</span>
                            </div>
                            `;
                }
            });

            let title = LinkagesDataLayerService.getLayerLabel(this.state.datalayerName);
            let content = `
                    <div class="info-window">
                        <div class="info-window-header">
                            <h5 class="info-window-title">${title}</h5>
                        </div>
                        <div class="info-window-body">
                          ${body}
                        </div>
                    </div>
                `;

            this.infoWindow.setContent(content);

            this.infoWindow.setPosition(event.latLng);
            this.infoWindow.open(map);

        });
    }

    removeAllDataLayers = async () => {
        await this.removeIbgeDataLayer();
        await this.removeZoneamentoDataLayer();
        await this.removeDataLayer();
    }

    addGoogleMapsDataLayer = async (geojsonData) => {

        await this.removeAllDataLayers();

        const datalayerName = this.state.datalayerName;

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        let datalayer = new google.maps.Data();

        await this.setDatalayerStyle(datalayer, datalayerName);
        await this.addDatalayerListener(datalayer);

        datalayer.addGeoJson(geojsonData)
        datalayer.setMap(map);

        this.setState({
            ...this.state,
            datalayer: datalayer
        })
    }

    /**
     * Remover datalayer da Linkage
     * @returns {Promise<void>}
     */
    removeDataLayer = async () => {
        if (this.state.datalayer === null) {
            return;
        }

        this.state.datalayer?.setMap(null);

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        for (let i = 0; i < this.state.datalayer; i++) {
            map.data.remove(this.state.datalayer[i]);
        }

    }

    handleAplyColorRanges = async () => {

        try {
            await this.setLoading(true);
            if (this.state.mapa_coropetico_current_showing) {
                let data = this.state.mapa_coropetico_current_showing?.data;
                let colorRanges = this.state.color_ranges[this.state.mapa_coropetico_current_showing.type];
                let dadoRange = this.state.mapa_coropetico_current_showing.config.dado_range;

                data = {
                    geojson: initializeColors(data.geojson, colorRanges, dadoRange)
                };

                await this.showIbgeInfo(this.state.mapa_coropetico_current_showing.type, data);
            }

            if (this.state.datalayerName) {
                await this.loadDataLayer();
            }
        } catch (e) {
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }


    getTransformedPayloadForSenso() {
        let polygons = [];
        let circles = this.state.circles;
        let polygonsOverlays = this.state.polygons;

        for (let i = 0; i < polygonsOverlays.length; i++) {
            let polygon = polygonsOverlays[i];

            let geojson = convertPolygonToGeojson(polygon)

            polygons.push({
                id: polygon.id,
                geojson: geojson
            })
        }


        for (let i = 0; i < circles.length; i++) {

            let circle = this.state.circles[i];

            if (circle.getMap() === null) {
                continue;
            }

            const center = [circle.getCenter().lng(), circle.getCenter().lat()];
            const radius = circle.getRadius();
            let polygonFromCircle = circleToPolygon(center, radius, 32);

            polygons.push({
                id: circles[i].id,
                geojson: polygonFromCircle
            });
        }

        let cidades = this.state.cidade;

        cidades = cidades.map((cidade) => {
            let cidadeParts = cidade.value.split('-');

            return {
                uf: cidadeParts[0],
                cidade: cidadeParts[1],
                id: cidade.value
            }

        });

        let retorno = { polygons, cidades };

        retorno.camada = this.state.datalayerName;
        retorno.poligonos = retorno.polygons
        retorno.ano = this.state.datalayerYear;
        retorno.anos = this.state.datalayerYears;
        retorno.field = this.state.datalayerColorProperty;
        retorno.hash = md5(JSON.stringify(retorno));

        return retorno;
    }

    setLoading = async (loading) => { await this.setState({ loading: loading }) }

    removeHeatMap = async () => {
        if (this.state.heatMap !== null) {
            this.state.heatMap.setMap(null);

            let empreendimentos = this.state.empreendimentos;

            for (let i = 0; i < empreendimentos.length; i++) {
                empreendimentos[i].show_marker = true;
                empreendimentos[i].customMarker = undefined;
            }

            await this.setState({ showMarkers: true, heatMap: null, empreendimentos: [...empreendimentos] });
        }
    }

    //oculta ou mostra os kmls de bairros carregados
    showKmlBairros = async (e) => {
        try {

            await this.setState({
                ...this.state,
                showKMl: e,
                loading: true
            });

        } catch (e) {
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    //Exibe ou não os marcadores agrupados com ClusterMarker
    //https://tomchentw.github.io/react-google-maps/#markerclusterer
    toggleUseCluster = async () => {
        try {
            await this.setLoading(true);
            await this.setState({ use_cluster: !this.state.use_cluster });
        } catch (error) {
            console.log(error);
        } finally {
            await this.setLoading(false);
        }
    }

    /**
     * Download de KML dos dados do Mapa
     * @returns {Promise<void>}
     */
    downloadKml = async () => {

        let payload = {
            ...this.state, polygons: [], circles: [], overlays: []
        }

        this.state.polygons.map((polygon) => {
            let polygonPath = getPolygonPath(polygon);
            payload.polygons.push(polygonPath);
        })

        payload.circles = await this.getCirclesPlainObjects();
        await KmlService.download(payload);
    }


    printMap = async () => {

        document.getElementById("btn-results").click();

        const legenda = document.getElementById('legenda-gradiente-polos');

        if (legenda) {
            legenda.classList.add('print-legenda-gradiente-polos');
        }

        const legendaHTML = legenda?.outerHTML || null;



        const map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        try {

            map.setOptions({
                disableDefaultUI: true,
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                drawingControl: false
            });

            await this.setState({
                left_side_bar_visible: false,
                loading: true,
                hide_search_box: true
            });

            await new Promise(resolve => setTimeout(resolve, 1000));

            const mapElement = document.getElementById('map-container');
            if (!mapElement) {
                return;
            }

            const canvas = await html2canvas(mapElement, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
            });

            await this.setState({
                mapScreenCaptureData: canvas.toDataURL('image/jpg'),
                show_modal_map_screen_capture: true,
                canvas: canvas
            });

            ClusterService.removeLegenda();


        } catch (error) {
            console.log(error);
        } finally {
            await map.setOptions({
                disableDefaultUI: false,
                zoomControl: true,
                streetViewControl: true,
                mapTypeControl: true,
                fullscreenControl: true,
                drawingControl: true
            });

            await this.setState({
                loading: false,
                hide_search_box: false,
            });
            if (legendaHTML) {
                ClusterService.removeLegenda();

                const parser = new DOMParser();
                const doc = parser.parseFromString(legendaHTML, 'text/html');
                const novaLegenda = doc.body.firstChild;
                map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(novaLegenda);

                setTimeout(() => {
                    novaLegenda.style.removeProperty('left');
                    novaLegenda.classList.remove('print-legenda-gradiente-polos');

                    novaLegenda.style.setProperty('left', '0', 'important');
                    novaLegenda.classList.add('legenda-fixada');
                }, 100);
            }
        }

    }

    /**
     * Salva dados do Mapa como Projeto
     * @returns {Promise<void>}
     */
    saveProject = async () => {
        try {
            await this.setState({
                ...this.state,
                loadingSaveProject: true
            });

            const payload = await this.createPayloadForProject();
            payload.datalayer = null;
            const response = await axios.post("/mapa-state/projeto", payload);

            await this.handleCloseProjectName();

            toast.success(response.data.message);

            await this.getProjects();
        } catch (error) {
            console.error("Erro ao salvar projeto:", error);

            if (error.response) {
                this.setState({
                    ...this.state,
                    errors_projeto: error.response.data.errors
                })
            }

        } finally {
            await this.setState({
                ...this.state,
                loadingSaveProject: false
            });
        }
    }

    /**
     * Monta o payload para salvar um projeto
     * @returns {Promise<Readonly<S>&{heatMap: null, heatMapLegendConfig: *[], polygons: *, overlays: *[], circles: unknown, heatMapConfig: {}}>}
     */
    createPayloadForProject = async () => {

        const polygonsPaths = this.state.polygons.map(polygon => ({
            name: polygon.name,
            polygon: getPolygonPath(polygon),
            color: polygon.color,
            fillColor: polygon.fillColor,
            strokeColor: polygon.strokeColor,
            fillOpacity: polygon.fillOpacity,
            strokeWeight: polygon.strokeWeight,
        }));


        const circles = await this.getCirclesPlainObjects();
        return {
            ...this.state,
            circles,
            heatMap: null,
            heatMapConfig: {},
            heatMapLegendConfig: [],
            polygons: polygonsPaths,
            overlays: [],
            share_users: this.state.project_share_users.map(user => user.id)
        };
    }


    /**
     * Busca os projetos salvos do usuário
     * @returns {Promise<void>}
     */
    getProjects = async () => {
        try {
            let projetos = [{ value: null, label: 'Selecione' }];
            const response = await axios.get(route('getMapaProjetos'));

            projetos = [...projetos, ...response.data.projects];

            await this.setState({
                ...this.state,
                projetos: projetos
            });
        } catch (error) {
            console.error("Erro ao carregar os nomes dos projetos", error);
        }
    }

    /**
     * Remove um projeto
     * @returns {Promise<void>}
     */
    deleteProject = async () => {

        try {
            let response = await axios.delete(route('mapa.project.delete', this.state.projeto));
            toast.success(response.data.message)

            await this.cleanState();
            await this.getProjects();
        } catch (error) {
            console.log(error);
        }

    }

    deleteWork = async () => {

        let projeto = [{ label: 'projeto', value: this.state.projeto }];

        axios.post(route('deleteMapaProjetoByName'), projeto).then(response => {
            alert(response.data.message)
        }).catch(error => {
            console.log("this is error", error);
        });
        await this.cleanState();
        await this.getProjects();

    }

    addPolygon = async (coordinate) => {

        let convertedCoordinates = [];

        coordinate.forEach((coord) => {
            convertedCoordinates.push({
                lat: coord[0], lng: coord[0],
            });
        });

        const polygon = new google.maps.Polygon({
            paths: convertedCoordinates,
            strokeColor: "#FF0000",
            strokeOpacity: 0.3,
            strokeWeight: 2,
            fillColor: this.getColor(),
            fillOpacity: 0.3,
        });

        polygon.type = 'Polígono';
        polygon.color = polygon.fillColor;
        polygon.id = this.generateRandomString();
        polygon.name = this.state.countPolygons + 1;

        polygon.setMap(window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);
    }

    setHeatMapWeightType = async (type) => { await this.setState({ heatMapWeightType: type }); }


    addHeatMap = async (config) => {

        let weightType = config.type;

        if (this.state.heatMap) {
            this.state.heatMap.setMap(null);
        }

        await this.setState({ heatMap: null, heatMapConfig: config })


        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        let heatMapaInfos = await this.getHeatMapWeights();

        let minIntensity = heatMapaInfos.minIntensity;
        let maxIntensity = heatMapaInfos.maxIntensity;
        let medianIntensity = 0;

        medianIntensity = parseInt(heatMapaInfos.maxIntensity / 2);

        let heatMap = new google.maps.visualization.HeatmapLayer({
            data: heatMapaInfos.heatMapData, dissipating: true, radius: 100, opacity: 0.4,
        });


        heatMap.setMap(map);


        this.setState({
            heatMap: heatMap,
            showMarkers: true,
            minIntensity: minIntensity,
            maxIntensity: maxIntensity,
            heatMapWeightType: weightType.value,
            medianIntensity: medianIntensity,
            heatMapConfig: config,
            heatMapLegendConfig: heatMapaInfos.heatMapLegendConfig,
            empreendimentos: [...this.state.empreendimentos],
            active_tab: 'legendas',
            left_side_bar_visible: true
        })
    }

    calculatePercentiles = async (field) => {

        if (field === 'oferta_inicial') {
            field = 'total_unidades';
        }

        let percentis = await percentile([12.5, 25, 32.5, 50, 62.5, 75, 87.5], this.state.empreendimentos, item => item[field]);

        return percentis.map((row) => row[field]);


    }


    getHeatMapWeights = async () => {
        return new Promise(async (resolve, reject) => {

            let percentis = await this.calculatePercentiles(this.state.heatMapConfig.type.value);

            let empreendimentos = this.state.empreendimentos;


            let weights = [];
            let heatMapData = [];

            let minIntensity = 0;
            let maxIntensity = 0;


            const heatMapLegendConfig = [];

            let colors = ['194D72', '3D8ABD', 'B1D974', '7CA83E', '5B7537', 'F1A30C', 'B29400', 'C50234']
            let previusPercentilIndex = 0;
            let increment = 1;

            if (!['oferta_final', 'oferta_inicial'].includes((this.state.heatMapConfig.type.value))) {
                increment = 0.1;
            }

            let min = percentis[0];
            percentis.forEach((percentile, index) => {


                if (index === 0) {
                    min = 0;
                } else {
                    min = percentis[previusPercentilIndex] + increment;
                }

                let max = percentile;

                if (['vgv_final', 'ticket_medio'].includes(this.state.heatMapConfig.type.value)) {
                    min = Number(min.toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                    max = Number(percentile.toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                }

                heatMapLegendConfig.push({
                    min: min,
                    max: max,
                    icon: `${import.meta.env.VITE_APP_URL}/img/marcadores/mapa_de_calor/${colors[index]}.png`
                })

                previusPercentilIndex = index;
            });

            min = percentis[percentis.length - 1] + increment;
            if (['vgv_final', 'ticket_medio'].includes(this.state.heatMapConfig.type.value)) {
                min = Number(min.toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            }


            heatMapLegendConfig.push({
                min: min,
                max: undefined,
                icon: `${import.meta.env.VITE_APP_URL}/img/marcadores/mapa_de_calor/${colors[colors.length - 1]}.png`
            })


            for (let i = 0; i < empreendimentos.length; i++) {

                let empreendimento = empreendimentos[i];
                let weight = empreendimento[this.state.heatMapConfig.type.value];

                if (this.state.heatMapConfig.type.value === 'oferta_inicial') {
                    weight = parseInt(empreendimento["total_unidades"]);
                }

                empreendimento.show_marker = true;

                if (this.state.heatMapConfig.type.value === 'oferta_inicial') {
                    let dataLancamento = new Date(empreendimento.data_lancamento);

                    if (dataLancamento < this.state.heatMapConfig.data_inicial || dataLancamento > this.state.heatMapConfig.data_final) {
                        empreendimento.show_marker = false;
                    }


                }

                if (weight <= percentis[0]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/194D72.png'
                }

                if (weight > percentis[0] && weight <= percentis[1]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/3D8ABD.png'
                }

                if (weight > percentis[1] && weight <= percentis[2]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/B1D974.png'
                }

                if (weight > percentis[2] && weight <= percentis[3]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/7CA83E.png'
                }

                if (weight > percentis[3] && weight <= percentis[4]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/5B7537.png'
                }

                if (weight > percentis[4] && weight <= percentis[5]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/F1A30C.png'
                }

                if (weight > percentis[5] && weight <= percentis[6]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/B29400.png'
                }

                if (weight > percentis[6]) {
                    empreendimento.customMarker = import.meta.env.VITE_APP_URL + '/img/marcadores/mapa_de_calor/C50234.png'
                }

                weights.push(weight);


                if (empreendimento.show_marker === true) {
                    heatMapData.push({
                        location: new google.maps.LatLng(empreendimento.location.coordinates[1], empreendimento.location.coordinates[0]),
                        weight: weight
                    });
                }

            }

            resolve({
                heatMapData: heatMapData,
                minIntensity: minIntensity,
                maxIntensity: maxIntensity,
                weights: weights,
                heatMapLegendConfig: heatMapLegendConfig
            });
        });
    }

    addCircle = async (circleProperties) => {

        const radius = circleProperties.radius;

        let newCircle = new google.maps.Circle({
            fillColor: circleProperties.fillColor,
            fillOpacity: 0.4,
            map: map,
            center: circleProperties.center,
            radius: radius
        });

        newCircle.id = circleProperties.id;
        newCircle.name = circleProperties.name;

        newCircle.type = circleProperties.type;
        newCircle.color = circleProperties.color;

        circle.setMap(window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);

        await this.setState({
            ...this.state,
            drawingMode: null,
            circles: [...this.state.circles, newCircle],
            overlays: [...this.state.overlays, newCircle]
        });

    }

    getCirclesPlainObjects = async () => {

        return new Promise((resolve, reject) => {
            let circles = [];

            for (let index = 0; index < this.state.circles.length; index++) {
                const circle = this.state.circles[index];

                let newCircle = {
                    latitude: circle.getCenter().lat(),
                    longitude: circle.getCenter().lng(),
                    radius: circle.radius,
                    name: circle.name,
                    type: circle.type,
                    color: circle.color,
                    fillColor: circle.fillColor,
                    strokeColor: circle.strokeColor,
                    fillOpacity: circle.fillOpacity,
                    strokeWeight: circle.strokeWeight,
                }

                circles.push(newCircle);
            }

            resolve(circles);
        });
    }


    /**
     * Esconde o Painel de Informações do Empreendimento
     */
    handleHideClicked = (event) => {
        event.preventDefault();

        this.setState({
            panel_empreendimento_visible: false,
            modal_empreendimento_visible: false,
        });
    }

    togglePainelEmpreendimento = () => {
        this.setState({
            panel_empreendimento_visible: !this.state.panel_empreendimento_visible,
            modal_empreendimento_visible: !this.state.modal_empreendimento_visible,
            currentShowing: undefined
        });
        document.getElementById("btn-results").click();

    }

    componentDidMount = async () => {
        window.circles = [];
        window.markers = [];
        window.refs = [];
        let currentPosition = await getBrowserGeolocation();
        this.timer = null;

        this.setState({ currentPosition: currentPosition, });

        if( !!window.google  ){
            this.infoWindow = new google.maps.InfoWindow();
        }
    }

    setLoadingKml = async (loading) => { }

    async componentDidUpdate(prevProps, prevState) {

        const map = window.googleMap?.context?.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        if(!map){
            return;
        }

        if (!this.mapClickListenerAdded) {
            map.addListener('click', () => { this.infoWindow?.close(); });
            this.mapClickListenerAdded = true;
        }

        if (prevState.empreendimentos !== this.state.empreendimentos ||
            prevState.use_cluster !== this.state.use_cluster ||
            prevState.showMarkers !== this.state.showMarkers) {

            if (this.markers.length > 0) {
                this.markers.forEach(marker => { marker.setMap(null) });
                this.markers = [];
            }

            if (this.state.empreendimentos.length > 0) {
                await this.initMarkers();

                if (this.state.use_cluster) {
                    this.markersClusterer = ClusterService.createEmpreendimentosCluster(map, this.markers);
                } else {

                    if (this.markersClusterer) {
                        this.markers.forEach(marker => { this.markersClusterer.removeMarker(marker); });
                        this.markersClusterer?.setMap(null);
                    }

                }
            }
        }

        if (prevState.polos_geradores !== this.state.polos_geradores ||
            prevState.use_cluster !== this.state.use_cluster ||
            prevState.show_polos_geradores !== this.state.show_polos_geradores) {

            if (this.markersPolosGeradores.length > 0) {
                this.markersPolosGeradores.forEach(marker => marker.setMap(null));
                this.markersPolosGeradores = [];
            }

            if (this.state.polos_geradores.length > 0) {

                await this.initMarkersPoloGeradores();

                if (this.state.use_cluster) {
                    if (this.markersClustererPolosGeradores) {
                        Object.values(this.markersClustererPolosGeradores).forEach(cluster => cluster.setMap(null));
                    }

                    const markersByCategory = {};
                    this.markersPolosGeradores.forEach(marker => {
                        const category = marker.main_category;
                        if (!markersByCategory[category]) {
                            markersByCategory[category] = [];
                        }
                        markersByCategory[category].push(marker);
                    });

                    this.markersClustererPolosGeradores = ClusterService.createPolosGeradoresCluster(map, markersByCategory);
                    ClusterService.addLegenda(
                        window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
                        polosGeradoresColor,
                        markersByCategory
                    );

                } else if (this.markersClustererPolosGeradores) {
                    Object.values(this.markersClustererPolosGeradores).forEach(cluster => cluster.setMap(null));
                    this.markersClustererPolosGeradores = {};
                    ClusterService.removeLegenda();
                }
            }
        }
    }

    initMarkersPoloGeradores = async () => {

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        if (!this.state.show_polos_geradores) {
            if (this.markersPolosGeradores.length > 0) {
                this.markersPolosGeradores.forEach((marker) => { marker.setMap(null); });
            }

            return;
        }

        this.state.polos_geradores.forEach(polo_gerador => {

            const glyphImg = document.createElement("img");

            glyphImg.src = polo_gerador.image;

            let position = {
                lat: polo_gerador.position.coordinates[1],
                lng: polo_gerador.position.coordinates[0]
            };

            let marker = new google.maps.marker.AdvancedMarkerElement({
                map: map,
                position: position,
                content: glyphImg,
                title: polo_gerador.title,
                gmpClickable: true,
            });

            marker.main_category = polo_gerador.main_category;
            marker.image = polo_gerador.image;

            marker.addEventListener('mouseover', (e) => { this.infoWindow = poloInfoWindow(polo_gerador, marker, this.infoWindow); });
            marker.addEventListener('mouseleave', (e) => { this.infoWindow.close(); });
            this.markersPolosGeradores.push(marker);
        });
    }


    getPadroes = () => {

        if (this.state.tipo_empreendimento.includes('Horizontal')) {
            return [...padroesVerticais, ...padroesHorizontais]
        }

        return padroesVerticais;

    }

    onRectangleComplete = async (rectangle) => {

        let bounds = rectangle.getBounds();
        let northEast = bounds.getNorthEast();
        let southWest = bounds.getSouthWest();

        let northWest = [northEast.lat(), southWest.lng()];
        let southEast = [southWest.lat(), northEast.lng()];

        let path = [
            [northEast.lat(), northEast.lng()],
            [northWest[0], northWest[1]],
            [southWest.lat(), southWest.lng()],
            [southEast[0], southEast[1]],
            [northEast.lat(), northEast.lng()]
        ];

        rectangle.id = 'retangulo-' + this.generateRandomString();
        rectangle.name = this.state.countRectangles + 1;
        rectangle.type = 'Retângulo';
        rectangle.path = path;

        rectangle.addListener("bounds_changed", async () => {
            await this.reloadEmpreendimentos();
        });

        await this.setState({
            ...this.state,
            drawingMode: null,
            polygons: [rectangle, ...this.state.polygons],
            overlays: [rectangle, ...this.state.overlays],
            countRectangles: this.state.countRectangles + 1,
            left_side_bar_visible: false
        });

        this.fitBounds(bounds);

        await this.reloadEmpreendimentos();

    }


    onPolygonComplete = async (polygon) => {
        try {
            let path = getPolygonPath(polygon);

            path.push(path[0]);

            polygon.type = 'Polígono';
            polygon.id = this.generateRandomString();
            polygon.path = path;
            polygon.color = polygon.color || this.getColor();
            polygon.strokeColor = polygon.strokeColor || "#000000";
            polygon.fillOpacity = polygon.fillOpacity || 0.5;
            polygon.strokeWeight = polygon.strokeWeight || 3;

            if (!polygon.name) {
                polygon.name = this.state.countPolygons + 1;
            }

            google.maps.event.addListener(polygon.getPath(), 'set_at', async () => {
                await this.reloadEmpreendimentos();
            });

            google.maps.event.addListener(polygon.getPath(), 'insert_at', async () => {
                await this.reloadEmpreendimentos();
            });


            await this.setState({
                ...this.state,
                drawingMode: null,
                polygons: [polygon, ...this.state.polygons],
                overlays: [polygon, ...this.state.overlays],
                countPolygons: this.state.countPolygons + 1,
                left_side_bar_visible: false
            });

            this.fitBounds(await this.getPolygonBounds(polygon));

            await this.reloadEmpreendimentos();

            google.maps.event.addListener(polygon, 'click', (event) => {
                this.editShapeName(polygon);
            });


        } catch (error) {
            console.log(error);
        }
    }

    cleanState = async () => {

        if (this.state.heatMap) {
            this.state.heatMap.setMap(null);
        }

        this.state.overlays.forEach((overlay) => {
            try {
                if (overlay.setMap !== undefined) {
                    overlay.setMap(null);
                }
            } catch (error) {
                console.log(error);
            }
        });

        this.state.kml_layers.forEach((kml_layer) => {
            try {
                if (kml_layer.setMap !== undefined) {
                    kml_layer.setMap(null);
                }
            } catch (error) {
                console.log(error);
            }
        });

        document.querySelector('#search_box').value = '';

        if (window.ibge_layer) {
            await this.removeIbgeDataLayer();
        }

        if (window.zoneamentoDataLayer) {
            await this.removeZoneamentoDataLayer();
        }

        if (this.state.datalayer) {
            await this.removeDataLayer();
        }

        this.markers.forEach((marker) => {
            marker.setMap(null);
        });


        this.setState({
            ...this.initialState,
            quartos: [],
            heatMap: null,
            showMarkers: true,
            use_cluster: false,
        });

        this.markers.forEach(marker => { this.markersClusterer?.removeMarker(marker); });
        this.markersClusterer?.setMap(null);
        if (this.markersClustererPolosGeradores) {
            Object.values(this.markersClustererPolosGeradores).forEach(cluster => cluster?.setMap(null));
        }
        this.markersClustererPolosGeradores = {};

        this.infoWindow = null;
        this.mapClickListenerAdded = false;
        this.markers = [];
        this.markersClusterer = null;
        this.markersPolosGeradores = [];
        this.markersClustererPolosGeradores = null;

        ClusterService.removeLegenda();

        await this.getProjects();


    }

    onRevendaMarkerClick = async (id) => {
        if ($("#card-results").hasClass("collapsed")) {
            $("#card-results").removeClass("collapsed");
            $("#btn-results").removeClass("btn-results-off");
            $(".side-panel").removeClass("side-panel-off");

            $(".sliding-panel-container").addClass("active");
            $("#results-icon").removeClass("fa-angle-double-left");
            $("#results-icon").addClass("fa-angle-double-right");
        }
        await this.setState({
            loading_empreendimento: true, // currentShowing: undefined,
        });

        let empreendimento = await EmpreendimentoServiceCrawler.getEmpreendimento(id.$oid);

        let selectedIcon = {
            position: {
                lat: empreendimento.location.coordinates[1], lng: empreendimento.location.coordinates[0],
            }, icon: "https://maps.google.com/mapfiles/kml/paddle/grn-stars.png",
        };

        await this.setState({
            currentShowing: empreendimento,
            panel_empreendimento_visible: true,
            modal_empreendimento_visible: true,
            selectedIcon: selectedIcon,
        });
        document.getElementById("btn-results").click();
        this.openPane();
    };

    onMarkerClick = async (empreendimento_selecionado) => {


        if ($("#card-results").hasClass('collapsed')) {
            $("#card-results").removeClass("collapsed");
            $("#btn-results").removeClass("btn-results-off");
            $(".side-panel").removeClass("side-panel-off");

            $('.sliding-panel-container').addClass('active');
            $("#results-icon").removeClass("fa-angle-double-left");
            $("#results-icon").addClass("fa-angle-double-right");

        }
        await this.setState({
            ...this.state, loading_empreendimento: true, currentShowing: undefined, loading: true
        });

        let empreendimento = await EmpreendimentoService.getEmpreendimento(empreendimento_selecionado._id);


        await this.setState({
            ...this.state,
            currentShowing: empreendimento,
            panel_empreendimento_visible: true,
            modal_empreendimento_visible: true,
            loading: false,
            left_side_bar_visible: false
        });


        document.getElementById("btn-results").click();
        return this.openPane();
    }


    generateRandomString = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    onCircleComplete = async (circle) => {

        circle.id = this.generateRandomString();
        circle.type = 'Círculo';
        circle.color = this.getColor();

        circle.name = circle.name !== undefined ? circle.name : this.state.circles.length + 1;

        google.maps.event.addListener(circle, 'radius_changed', (event) => {
            this.onCircleRadiusChanged(circle);
        });

        google.maps.event.addListener(circle, 'click', (event) => {
            this.editShapeName(circle);
        });

        await this.setState({
            ...this.state,
            drawingMode: null, //
            circles: [circle, ...this.state.circles],
            overlays: [circle, ...this.state.overlays],
            left_side_bar_visible: false

        });

        this.fitBounds(circle.getBounds());

        await this.reloadEmpreendimentos();

    }

    openPane = () => {
        this.setState({
            ...this.state,
            isSlideOpen: true,
        });
    }


    handleAnoLancamentoChanged = async (e) => {
        this.setState({
            ...this.state, ano_lancamento: e.value
        });

    }
    handleMesAnoLancamentoChanged = async (e) => {

        await this.setState({
            ...this.state, mes_ano_lancamento: e
        });

    }

    handleEstagioChanged = async (e) => {
        this.setState({
            ...this.state, estagio: e.value
        });
    }

    closePane = () => {
        this.setState({
            isSlideOpen: false
        });
    }

    handleTipoEmpreendimentoChanged = async (value) => {
        let tipos = this.state.tipo_empreendimento;

        if (!tipos.includes(value)) {
            this.setState({
                tipo_empreendimento: [...tipos, value]
            });
        } else {
            tipos.splice(tipos.indexOf(value), 1);

            this.setState({
                tipo_empreendimento: tipos
            });
        }

        //this.reloadEmpreendimentos();
    }

    handleIncluirMonitoradasChanged = async (e) => {
        await this.setState({ check_incluir_monitoradas: !this.state.check_incluir_monitoradas });
    }

    handleIncorporadoraChanged = async (e) => {
        if (e === null) {
            await this.setState({
                ...this.state, incorporadoras: []
            });

            return;
        }

        let incorporadoras = [];
        e.forEach((option) => {
            if (!incorporadoras.includes(option)) {
                incorporadoras = [...incorporadoras, option];
            }

        });

        await this.setState({
            incorporadoras: [...incorporadoras], movimentar_mapa: true
        });

    }


    handleNomeEmpreendimentoChanged = async (e) => {
        if (e == null) {
            await this.setState({
                nome_empreendimento: []
            });

            return;
        }

        let nome_empreendimento = [];
        e.forEach((option) => {
            if (!nome_empreendimento.includes(option)) {
                nome_empreendimento = [...nome_empreendimento, option];
            }
        });

        await this.setState({
            nome_empreendimento: [...nome_empreendimento], movimentar_mapa: true
        });

    }

    clearDefaultEmpreendimentos = async () => {
        await this.setState({ ...this.state, buscaEmpreendimentossDefaultOptions: [] });
    }

    searchEmpreendimentos = async (inputQuery) => {
        if (inputQuery.length > 1) {

            try {
                let endpoint = '/empreeendimentos-options?nome=' + inputQuery;

                if (this.state.cidade !== '' && this.state.cidade.length > 0) {

                    let cidades = '';

                    this.state.cidade.forEach((cidade) => {
                        cidades += cidade.label + ',';
                    });

                    endpoint += `&cidade=${cidades.trim().slice(0, -1)}`;


                }

                if (this.state.estado.length > 0) {

                    let estados = '';

                    this.state.estado.forEach((estado) => {
                        estados += estado + ',';
                    });

                    endpoint += `&estado=${estados.trim().slice(0, -1)}`;
                }

                let empreendimentos = await axios.get(endpoint);

                await this.setState({ ...this.state, buscaEmpreendimentossDefaultOptions: empreendimentos.data });

                return empreendimentos.data;
            } catch (error) {
                console.log(error);
            }
        }
    }


    reloadEmpreendimentosWithoutMetaData = async () => {
        //Caso não tenha formas desenhadas no mapa a busca será por cidade
        if (this.thereAreDrownShapes() === false) {
            if (this.state.overlays.length === 0 && this.state.cidade.length === 0 && this.state.estado.length === 0 && this.state.regiao.length == 0) {
                alert('Desenhe uma área no Mapa ou digite uma Cidade na caixa de busca do mapa');
                return;
            }

            return await this.reloadEmpreendimentosOnCidadeWithouMetaData()
        }

        return await this.reloadEmpreendimentosWithouMetaData();
    }


    reloadEmpreendimentos = async () => {

        if (this.thereAreDrownShapes() === false) {
            if (this.state.overlays.length === 0 && this.state.cidade.length === 0 && this.state.estado.length === 0 && this.state.regiao.length == 0) {
                toast.error("Desenhe uma área no Mapa ou digite uma Cidade na caixa de busca do mapa");
                return;
            }
        }

        try {

            window.ibge_layer = null;

            if (this.state.heatMap) {
                this.state.heatMap.setMap(null);
            }

            if (this.state.ibgeDataLayer) {
                this.state.ibgeDataLayer.setMap(null);
            }

            await this.setState({
                ...this.state,
                loading: true,
                loadingMetadata: true,
                empreendimentos: [],
                polos_geradores: [],
                heatMap: null,
                selectedIcon: undefined,

            });

            await this.reloadEmpreendimentosWithoutMetaData();

            if (this.thereAreDrownShapes() === false) {
                if (this.state.overlays.length === 0 && this.state.cidade.length === 0 && this.state.estado.length === 0 && this.state.regiao.length == 0) {
                    alert('Desenhe uma área no Mapa ou digite uma Cidade na caixa de busca do mapa');
                    return;
                }

                return this.reloadEmpreendimentosOnCidade();
            }

            let empreendimentos = [];
            let polosGeradores = [];
            let revendaLocacao = [];

            const {
                empreendimentos: empreendimentosInCircles,
                polos_geradores: polosGeradoresOnCircle
            } = await this.reloadEmpreendimentosOnCircle();

            const {
                empreendimentos: empreendimentosOnPolygons,
                polos_geradores: polosGeradoresOnPolygons
            } = await this.reloadEmpreendimentosOnPolygons();

            empreendimentos = [...empreendimentosInCircles, ...empreendimentosOnPolygons];
            polosGeradores = [...polosGeradoresOnCircle, ...polosGeradoresOnPolygons];

            if (this.state.showResaleOrLocationMarkers) {
                const { empreendimentos: revendaPolygons } = await this.reloadRevendaEmpreendimentosOnPolygons();
                const { empreendimentos: revendaCircle } = await this.reloadRevendaEmpreendimentosOnCircle();
                revendaLocacao = [...revendaCircle, ...revendaPolygons];
            }

            //retira os empreendimentos duplicados
            let empreedimentosWithoutDuplicate = await this.removeDuplicates(empreendimentos);

            await this.mapBuilding(empreedimentosWithoutDuplicate);

            let isSlideOpen = empreedimentosWithoutDuplicate.length > 0 || polosGeradores.length > 0;

            await this.setState({
                ...this.state,
                empreendimentos: empreedimentosWithoutDuplicate,
                polos_geradores: polosGeradores,
                revendaLocacao: revendaLocacao,
                isSlideOpen: isSlideOpen
            });

            if (this.state.ranges.length > 0) {
                await this.replaceMarkers();
            }

            if (this.state.revendaLocacao.length > 0) {
                await this.replaceRevendaMarkers()
            }

            await this.fitMap();

            if (empreedimentosWithoutDuplicate.length > 0) {

                if (this.state.showRenda) {
                    await this.loadMapaCloropetico(this.state.mapa_coropetico_current_showing?.type);
                }

                if (Object.keys(this.state.heatMapConfig).length > 0) {
                    await this.addHeatMap(this.state.heatMapConfig);
                }

            } else {
                toast.warn('Nenhum resultado com os parametros fornecidos')
            }

        } catch (e) {
            console.log(e);
        } finally {
            await this.setState({
                ...this.state,
                loading: false,
            });
        }
    }

    fitMap = async () => {
        if (this.state.movimentar_mapa && this.state.empreendimentos.length > 0) {
            try {
                let bounds = new google.maps.LatLngBounds();
                this.state.empreendimentos.forEach((empreendimento) => {
                    let coords = {
                        lng: empreendimento.location.coordinates[0],
                        lat: empreendimento.location.coordinates[1]
                    }
                    bounds.extend(coords);
                });

                this.fitBounds(bounds);
            } catch (error) {
                console.log(error)
            }
        }
    }

    handlePadraoChanged = async (e) => {
        await this.setState({
            ...this.state,
            padrao: e.value,
        });
    }

    /**
     * Carregar projeto
     * @param e
     * @returns {Promise<void>}
     */
    handleProjetoChanged = async (e) => {

        this.setState({
            ...this.state,
            loading: true
        });

        await this.cleanState();
        await this.getProjects();

        const projetoResponse = await axios.get(route('mapa.project.show', e.value));
        const projetoData = projetoResponse.data.project;

        let ponto = {
            lat: parseFloat(projetoData.lat),
            lng: parseFloat(projetoData.lng)
        };

        let cidade = JSON.parse(projetoData.cidade) || [];
        let estado = JSON.parse(projetoData.estado) || [];
        //verificar se bairros é um objeto json ou uma string
        let bairros = [];

        if(typeof projetoData.bairros === 'string'){
            bairros = JSON.parse(projetoData.bairros) || [];
        }

        if(typeof projetoData.bairros === 'object'){
            bairros = projetoData.bairros || [];
        }


        let estagio = [];

        if( typeof projetoData.estagio === 'string' ){
            estagio = JSON.parse(projetoData.estagio);
        }

        if( typeof projetoData.estagio === 'object' ){
            estagio = projetoData.estagio;
        }

        let nome_empreendimentos = JSON.parse(projetoData.nome_empreendimento)?.map((empreendimento) => {
            return { label: empreendimento, value: empreendimento };
        }) || [];

        let parseProjectData = await this.parseProjectData(projetoData);

        if (parseProjectData.datalayerName) {
            parseProjectData.datalayerFriendlyName = LinkagesDataLayerService.getLayerLabel(parseProjectData.datalayerName);
            parseProjectData.datalayerColorPropertyOptions = LinkagesDataLayerService.getOptionsForColorMap(parseProjectData.datalayerName);
        }

        let mes_ano_lancamento = projetoData.mes_ano_lancamento != null ? new Date(projetoData.mes_ano_lancamento) : '';

        let bairrosOptions = [];

        for ( let x = 0; x < cidade.length; x++ ) {
            let newBairros = await this.fetchBairros(cidade[x].label);
            bairrosOptions = [...bairrosOptions, ...newBairros];
        }

        let ano_lancamento = [];

        if( projetoData.ano_lancamento != null ){
            if(typeof ano_lancamento === 'string'){
                ano_lancamento = JSON.parse(projetoData.ano_lancamento);
            }

            if(typeof ano_lancamento === 'object'){
                ano_lancamento = projetoData.ano_lancamento;
            }

            ano_lancamento = ano_lancamento.map((ano) => {
                return parseInt(ano);
            });

        }

        const updateState = {
            projeto: e.value,
            movimentar_mapa: true,
            polos_geradores: [],
            show_polos_geradores: false,
            overlay_cidade: true,
            cidade: cidade,
            estado: estado,
            estadosSelecionados: estado,
            bairrosOptions: bairrosOptions,
            ano_lancamento: ano_lancamento,
            bairros: bairros,
            pontos: [ponto],
            ...parseProjectData,
            nome_empreendimento: [...nome_empreendimentos],
            mes_ano_lancamento: mes_ano_lancamento,
            estagio: estagio
        };

        this.setState(updateState);

        if (projetoData?.polignos != null) {
            const polygons = JSON.parse(projetoData.polignos);
            polygons.forEach(polygon => this.createAndAddPolygon(polygon));
        }

        if (projetoData?.manualCircles != null) {
            const manualCircles = JSON.parse(projetoData.manualCircles);


            for (let i = 0; i < manualCircles.length; i++) {
                let circle = manualCircles[i];

                let color = (circle.color || circle.fillColor) || this.getColor();
                let strokeColor = circle.strokeColor || "#000000";
                let fillOpacity = circle.fillOpacity || 0.5;
                let strokeWeight = circle.strokeWeight || 3;

                let center = { lat: parseFloat(circle?.latitude), lng: parseFloat(circle?.longitude) };

                if (circle.center) {

                    center = {
                        lat: parseFloat(circle.center.lat),
                        lng: parseFloat(circle.center.lng)
                    };

                }

                let newCircle = new google.maps.Circle({
                    ...defaultCircleOptions,
                    center: center,
                    radius: circle.radius,
                    name: circle.name,
                    type: circle.type || 'Círculo',
                    color: color,
                    fillColor: color,
                    id: circle.id,
                    strokeColor: strokeColor,
                    fillOpacity: fillOpacity,
                    strokeWeight: strokeWeight,
                    draggable: false,
                    // clickable: false,
                    editable: false,
                });


                if (circle.strokeWeight) {
                    newCircle.strokeWeight = circle.strokeWeight
                }
                newCircle.setMap(window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);

                await this.onCircleComplete(newCircle);
            }
        }

        await this.reloadEmpreendimentos();
    }

    parseProjectData = async (projetoData) => {
        const fields = [
            'tipo_empreendimento', 'quartos', 'padrao', 'status',
            'incorporadoras', 'address',
            'area_maior_que', 'area_menor_que', 'valor_maior_que', 'valor_menor_que',
            'valor_metro_maior_que', 'valor_metro_menor_que', 'juros_minimo', 'juros_maximo',
            'valor_parcela_minima', 'valor_parcela_maxima', 'parcelas_minimo', 'parcelas_maximo',
            'raio', 'ranges', 'color_ranges',
            'porcentagem_vendida_minima', 'porcentagem_vendida_maxima',
        ];

        const result = fields.reduce((acc, field) => {
            if (projetoData?.[field] != null) {
                acc[field] = typeof projetoData[field] === 'string' ? JSON.parse(projetoData[field]) : projetoData[field];
            }
            return acc;
        }, {});

        // JSON.stringify serializa Infinity como null; restaura os valores ao carregar o projeto
        if (result.color_ranges) {
            Object.keys(result.color_ranges).forEach(key => {
                if (Array.isArray(result.color_ranges[key])) {
                    result.color_ranges[key] = result.color_ranges[key].map(range => ({
                        ...range,
                        min: range.min === null ? -Infinity : range.min,
                        max: range.max === null ? Infinity : range.max,
                    }));
                }
            });
        }

        return result;
    }

    createAndAddPolygon = async (polygonData, aditionalOptions = {}) => {

        const polygons = polygonData?.polygon ?? polygonData;
        const name = polygonData?.name;
        const color = (polygonData.color || polygonData.fillColor) || this.getColor();
        let strokeColor = polygonData.strokeColor || "#000000";
        let fillOpacity = polygonData.fillOpacity || 0.5;
        let strokeWeight = polygonData.strokeWeight || 3;

        const coordinates = polygons.map(coordinate => ({ lat: coordinate[0], lng: coordinate[1] }));
        const mapPolygon = new google.maps.Polygon({
            ...defaultPolygonOptions,
            paths: coordinates,
            color: color,
            fillColor: color,
            name: name,
            strokeColor: strokeColor,
            fillOpacity: fillOpacity,
            strokeWeight: strokeWeight,
            draggable: false,
            // clickable: false,
            editable: false,
            ...aditionalOptions
        });

        if (name) {
            mapPolygon.name = name;
        }

        mapPolygon.setMap(window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);
        await this.onPolygonComplete(mapPolygon);
    }

    handleAreaMinimaChanged = async (e) => {
        await this.setState({
            area_maior_que: parseFloat(e.target.value)
        });
    }

    /**
     * Altera o valor da porcentagem vendida minima
     * @param e
     * @returns {Promise<void>}
     */
    handlePorcentagemVendidaMinimaChanged = async (e) => {
        await this.setState({
            porcentagem_vendida_minima: parseFloat(e.target.value)
        });
    }

    /**
     * Altera o valor da porcentagem vendida maxima
     * @param e
     * @returns {Promise<void>}
     */
    handlePorcentagemVendidaMaximaChanged = async (e) => {
        await this.setState({
            porcentagem_vendida_maxima: parseFloat(e.target.value)
        });
    }


    handleRaioChanged = async (e) => {
        window.circles.forEach((circle) => {
            circle.setRadius(parseInt(e.target.value))
        });
        await this.setState({
            raio: parseInt(e.target.value)
        });
    }

    handleAreaMaximaChanged = async (e) => {
        await this.setState({
            area_menor_que: parseFloat(e.target.value)
        });
    }

    handleStatusChanged = async (e) => {
        await this.setState({
            status: e.value
        });
    }

    handleRetrofitChanged = async (e) => {
        await this.setState({
            retrofit: e.value
        });
    }

    handleRegiaoChanged = async (e) => {
        await this.setState({
            regiao: e.value
        });
    }

    handleTipoChanged = async (e) => {
        if (e === null) {
            await this.setState({
                ...this.state, tipo_negocio: [],
            });

            return;
        }

        let tipo_negocio = [];
        e.forEach((tipoSelected) => {
            if (tipoSelected.value === "Todos") {
                tipo_negocio = [{ value: "Venda", label: "Revenda" }, { value: "Aluguel", label: "Locação" },];
                return;
            }

            if (!tipo_negocio.includes(tipoSelected)) {
                tipo_negocio.push(tipoSelected);
            }
        });

        await this.setState({
            tipo_negocio: tipo_negocio,
        });
    };

    handleBairrosChanged = async (e) => {
        await this.setState({
            bairros: e.value, movimentar_mapa: true
        });
    }

    handleValorMinimoChanged = async (value) => {
        await this.setState({
            valor_maior_que: value
        });
    }

    handleValorMaximoChanged = async (value) => {
        await this.setState({
            valor_menor_que: value
        });
    }

    handleValorMetroMinimoChanged = async (value) => {
        await this.setState({
            valor_metro_maior_que: value
        });
    }

    handleJurosMinimoChanged = async (e) => {
        this.setState({
            juros_minimo: Number(e.target.value)
        });
    }

    handleJurosMaximoChanged = async (e) => {
        this.setState({
            juros_maximo: Number(e.target.value)
        });
    }

    handleParcelasMinimoChanged = async (e) => {
        this.setState({
            parcelas_minimo: Number(e.target.value)
        });
    }

    handleParcelasMaximoChanged = async (e) => {
        this.setState({
            parcelas_maximo: Number(e.target.value)
        });
    }

    handleValorMetroMaximoChanged = async (value) => {

        this.setState({
            valor_metro_menor_que: value
        });
    }

    handleValorParcelaMaximaChanged = async (value) => {

        this.setState({
            valor_parcela_maxima: value
        });
    }

    handleValorParcelaMinimaChanged = async (value) => {

        this.setState({
            valor_parcela_minima: value
        });
    }

    handleNameProjectChanged = async (e) => {
        this.setState({
            project_name: e.target.value
        });
    }

    handleQuartosChanged = async (value) => {

        let quartos = [...this.state.quartos];

        if (!quartos.includes(value)) {
            quartos.push(value);
        }else {
            let index = quartos.indexOf(value);
            quartos.splice(index, 1);
        }

        await this.setState({
            ...this.state, quartos: [...quartos]
        });
    }

    handleVagasChanged = async (e) => {
        const value = parseInt(e.target.value);

        let vagas = this.state.vagas;

        if (e.target.checked && !vagas.includes(value)) {
            vagas.push(value);
        }

        if (!e.target.checked && vagas.includes(value)) {
            var index = vagas.indexOf(value);

            if (index > -1) {
                vagas.splice(index, 1);
            }
        }

        await this.setState({
            ...this.state, vagas: vagas
        });

        //this.reloadEmpreendimentos();
    }

    handleClusterChanged = async (e) => {
        await this.setState({
            ...this.state,
            cluster: e.value
        })
    }

    removeDuplicates = async (empreendimentos) => {

        return new Promise((resolve, reject) => {
            let empreendimentosSet = new Set();

            let empreendimentosWithoutDuplicate = empreendimentos.filter((empreendimento) => {
                const duplicate = empreendimentosSet.has(empreendimento._id);
                empreendimentosSet.add(empreendimento._id);
                return !duplicate;
            });

            resolve(empreendimentosWithoutDuplicate);
        });
    }

    reloadRevendaEmpreendimentosOnCircle = async () => {
        var empreendimentos = [];

        if (this.state.circles.length > 0) {
            for (let x = 0; x < this.state.circles.length; x++) {
                let circle = this.state.circles[x];

                if (circle.getMap() === null) {
                    continue;
                }

                const center = circle.getCenter();
                const radius = circle.getRadius();
                const color = circle.color;

                let empreendimentosResponse = await EmpreendimentoServiceCrawler.getEmpreendimentosWithinRadius(center.lat(), center.lng(), radius, this.state);
                circle.excel = empreendimentosResponse.data.excel;
                circle.count_buildings = empreendimentosResponse.data.count_buildings;
                circle.count_buildings_venda = empreendimentosResponse.data.count_buildings_venda;
                circle.count_buildings_aluguel = empreendimentosResponse.data.count_buildings_aluguel;
                circle.info_venda = empreendimentosResponse.data.info_venda;
                circle.info_aluguel = empreendimentosResponse.data.info_aluguel;

                let empreendimentosFromResponse = empreendimentosResponse.data.empreendimentos;

                empreendimentosFromResponse.map((empreendimento) => {
                    empreendimento.color = color;
                });

                let empreendimentosWithoutDuplicates = await this.removeDuplicates([...this.state.empreendimentos, ...empreendimentosFromResponse,]);

                empreendimentos = [...empreendimentos, ...empreendimentosWithoutDuplicates,];
            }
        }

        return { empreendimentos };
    }; //fim reloadEmpreendimentosOnCircle

    reloadEmpreendimentosOnCircle = async () => {


        var empreendimentos = [];
        var polos_geradores = [];

        if (this.state.circles.length > 0) {
            for (let x = 0; x < this.state.circles.length; x++) {
                let circle = this.state.circles[x];

                if (circle.getMap() === null) {
                    continue;
                }

                const center = circle.getCenter();
                const radius = circle.getRadius();
                const color = circle.color;

                let empreendimentosResponse = await EmpreendimentoService.getEmpreendimentosWithinRadius(center.lat(), center.lng(), radius, this.state);

                circle.meta_data = empreendimentosResponse.data.meta_data;
                circle.cache_key = empreendimentosResponse.data.meta_data.cache_key;

                if (this.state.show_polos_geradores) {

                    let polosGeradoresResponse = await PolosGeradoresService.getPolosGeradoresWithinRadius(center.lat(), center.lng(), radius, this.getPolosGeradoresTypesAsArray());
                    circle.polos_geradores = polosGeradoresResponse.polos_geradores;
                    polos_geradores = [...polosGeradoresResponse.polos_geradores];
                    circle.polos_geradores_cache_key = polosGeradoresResponse.cache_key;

                }

                let empreendimentosFromResponse = empreendimentosResponse.data.empreendimentos;

                empreendimentosFromResponse.map((empreendimento) => {
                    empreendimento.color = color;
                });

                let empreendimentosWithoutDuplicates = await this.removeDuplicates([...this.state.empreendimentos, ...empreendimentosFromResponse]);

                empreendimentos = [...empreendimentos, ...empreendimentosWithoutDuplicates];
            }
        }

        return { empreendimentos, polos_geradores };
    }//fim reloadEmpreendimentosOnCircle


    reloadRevendaEmpreendimentosOnPolygons = async () => {
        let empreendimentos = [];

        if (this.state.polygons.length > 0) {
            for (let x = 0; x < this.state.polygons.length; x++) {
                let polygon = this.state.polygons[x];

                if (polygon.getMap() === null) {
                    continue;
                }

                let path = getPolygonPath(polygon);
                path.push(path[0]);

                let empreendimentosResponse = await EmpreendimentoServiceCrawler.getEmpreendimentosWithinPolygon(path, this.state);

                polygon.excel = empreendimentosResponse.data.excel;
                polygon.count_buildings = empreendimentosResponse.data.count_buildings;
                polygon.count_buildings_venda = empreendimentosResponse.data.count_buildings_venda;
                polygon.count_buildings_aluguel = empreendimentosResponse.data.count_buildings_aluguel;
                polygon.info_venda = empreendimentosResponse.data.info_venda;
                polygon.info_aluguel = empreendimentosResponse.data.info_aluguel;

                let empreendimentosFromResponse = empreendimentosResponse.data.empreendimentos;

                empreendimentosFromResponse.map((empreendimento) => {
                    empreendimento.color = polygon.color;
                });

                empreendimentos = [...empreendimentos, ...empreendimentosResponse.data.empreendimentos,];
            }
        }

        return { empreendimentos };
    };

    //Recarregar empreendimentos com polignos
    reloadEmpreendimentosOnPolygons = async () => {
        let empreendimentos = [];
        let polos_geradores = [];

        if (this.state.polygons.length > 0) {
            for (let x = 0; x < this.state.polygons.length; x++) {
                let polygon = this.state.polygons[x];

                if (polygon.getMap() === null) {
                    continue;
                }

                let path = getPolygonPath(polygon);
                path.push(path[0]);


                let empreendimentosResponse = await EmpreendimentoService.getEmpreendimentosWithinPolygon(path, this.state);

                polygon.meta_data = empreendimentosResponse.data.meta_data;
                if (polygon.fillColor === 'transparent') {
                    polygon.color = polygon.strokeColor;
                } else {
                    polygon.color = polygon.fillColor;
                }
                let empreendimentosFromResponse = empreendimentosResponse.data.empreendimentos;


                empreendimentosFromResponse.map((empreendimento) => {
                    empreendimento.color = polygon.color;
                });

                let polosGeradoresResponse = [];
                if (this.state.show_polos_geradores) {

                    polosGeradoresResponse = await PolosGeradoresService.getPolosGeradoresWithinPolygon(path, this.getPolosGeradoresTypesAsArray());
                    polos_geradores = [...polos_geradores, ...polosGeradoresResponse.polos_geradores];
                    polygon.polos_geradores_cache_key = polosGeradoresResponse.cache_key;

                }

                polygon.polos_geradores = polosGeradoresResponse.polos_geradores;


                empreendimentos = [...empreendimentos, ...empreendimentosResponse.data.empreendimentos];

            }
        }

        return { empreendimentos, polos_geradores: polos_geradores };
    }


    reloadEmpreendimentosOnCidade = async () => {

        let overlay = {};

        let empreendimentosResponse = await EmpreendimentoService.getEmpreendimentoOnCidade(this.state);

        overlay.meta_data = empreendimentosResponse.data.meta_data;
        overlay.type = 'cidade';
        overlay.id = 'cidades';
        overlay.color = this.getColor();


        let empreendimentosFromResponse = empreendimentosResponse.data.empreendimentos;

        this.mapBuilding(empreendimentosFromResponse);


        let polos_geradores = [];

        if (this.state.show_polos_geradores) {
            let polosGeradoresResponse = await PolosGeradoresService.getPolosGeradoresFromCity(this.state.cidade, this.state.estadosSelecionados.length > 0 ? this.state.estadosSelecionados : this.state.estado, this.getPolosGeradoresTypesAsArray());

            overlay.polos_geradores = polosGeradoresResponse.polos_geradores;
            overlay.polos_geradores_cache_key = polosGeradoresResponse.cache_key;

            if(polosGeradoresResponse.polos_geradores.length > 1000) {
                this.setState({ use_cluster: true });
            }

            polos_geradores = [...polosGeradoresResponse.polos_geradores];
        }

        let revendaLocacao = [];
        if (this.state.showResaleOrLocationMarkers) {

            let revendaResponse = await EmpreendimentoServiceCrawler.getEmpreendimentoOnCidade(this.state)

            revendaLocacao = revendaResponse.data.empreendimentos;
            overlay.excel = revendaResponse.data.excel;
            overlay.count_buildings = revendaResponse.data.count_buildings;
            overlay.count_buildings_venda = revendaResponse.data.count_buildings_venda;
            overlay.count_buildings_aluguel = revendaResponse.data.count_buildings_aluguel;
            overlay.info_venda = revendaResponse.data.info_venda;
            overlay.info_aluguel = revendaResponse.data.info_aluguel;


        }

        let isSlideOpen = empreendimentosFromResponse.length > 0 || polos_geradores.length > 0;

        await this.setState({
            ...this.state,
            empreendimentos: empreendimentosFromResponse,
            overlays: [overlay, ...this.state.overlays],
            polos_geradores: [...polos_geradores],
            revendaLocacao: revendaLocacao,
            overlay_cidade: true,
            loadingMetadata: false,
            isSlideOpen: isSlideOpen,
        });

        if (this.state.kml_bairros.length > 0) {

            await this.setState({
                ...this.state, showKMl: false
            });

            if (this.state.kmls_to_show.length > 0) {
                this.cleanKmlLayers();
            }

            await this.loadKml();
        }

        if (this.state.revendaLocacao.length > 0) {
            await this.replaceRevendaMarkers()
        }

        if (this.state.empreendimentos.length > 0) {
            if (this.state.ranges.length > 0) {
                await this.replaceMarkers();
            }

            if (Object.keys(this.state.heatMapConfig).length > 0) {
                await this.addHeatMap(this.state.heatMapConfig);
            }


            await this.fitMap();
            this.openPane();


            if (this.state.showRenda) {
                await this.showIbgeInfo();
            }


        } else {
            if (this.state.polos_geradores.length > 0) {
                this.openPane();
            }

            toast.warn('Nenhum resultado com os parametros fornecidos na cidade')
        }

    }

    reloadEmpreendimentosOnCidadeWithouMetaData = async () => {

        let response = await SimpleEmpreendimentosService.getEmpreendimentoOnCidade(this.state);

        await this.setState({
            empreendimentos: [...response.data],
            overlay_cidade: true,
            loading: false,
            loadingMetadata: true,
            isSlideOpen: response.data.length > 0,
        });

        await this.fitMap();

    }

    initMarkers = async () => {

        if (!this.state.showMarkers) {
            if (this.markers.length > 0) {
                this.markers.forEach((marker) => {
                    marker.setMap(null);
                });
            }

            return;
        }

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        for (let i = 0; i < this.state.empreendimentos.length; i++) {
            let empreendimento = this.state.empreendimentos[i];

            if (empreendimento.show_marker) {


                const glyphImg = document.createElement("img");

                let icon = empreendimento.marker;


                let pinElement = null;

                if (empreendimento.customMarker) {

                    if (typeof empreendimento.customMarker === 'string') {
                        icon = empreendimento.customMarker;
                    }

                    if (typeof empreendimento.customMarker === 'object') {
                        pinElement = new google.maps.marker.PinElement({
                            background: empreendimento.customMarker.background,
                            borderColor: empreendimento.customMarker.borderColor,
                            glyphColor: empreendimento.customMarker.glyphColor,
                            scale: empreendimento.customMarker?.scale || 1,
                        });
                    }

                }

                glyphImg.src = icon;

                let position = {
                    lat: empreendimento.location.coordinates[1],
                    lng: empreendimento.location.coordinates[0]
                };

                let content = glyphImg;

                if (pinElement) {
                    content = pinElement.element;
                }

                let marker = new google.maps.marker.AdvancedMarkerElement({
                    map: map,
                    position: position,
                    content: content,
                    title: empreendimento.nome,
                    gmpClickable: true
                });

                marker.addEventListener('mouseover', (e) => {
                    this.infoWindow = empreendimentoInfoWindow(empreendimento, marker, this.infoWindow);
                });

                marker.addEventListener('mouseleave', (e) => { this.infoWindow.close(); });

                marker.addEventListener('gmp-click', (e) => { this.onMarkerClick(empreendimento); });

                this.markers.push(marker);
            }
        }
    }

    reloadEmpreendimentosWithouMetaData = async () => {

        let response = await ReloadBuildingsWithoutMetaData.reloadBuildingsWithoutMetaData(this.state);

        let empreedimentosWithoutDuplicate = await this.removeDuplicates(response);

        let isSlideOpen = empreedimentosWithoutDuplicate.length > 0;

        await this.setState({
            empreendimentos: empreedimentosWithoutDuplicate,
            loading: false,
            loadingMetadata: false,
            isSlideOpen: isSlideOpen
        })

        if (this.state.ranges.length > 0) {
            await this.replaceMarkers();
        }

        if (empreedimentosWithoutDuplicate.length === 0) {
            toast.warn('Nenhum resultado com os parametros fornecidos')
        }

        this.fitMap();

    }

    setLocation = async (place) => {
        try {

            this.setState({
                ...this.state, loading: true
            });

            let latitude = place[0].geometry.location.lat();
            let longitude = place[0].geometry.location.lng();

            //adiciona um Marca no Ponto da Busca
            let ponto = {
                lat: latitude, lng: longitude
            };


            const reverse = await geolocationService.reverse(latitude, longitude, place);

            if(reverse.uf) {
                this.state.estadosSelecionados = [reverse.uf];
            }

            const zoneamentoService = new ZoneamentoService();

            const zoneamentoAvailableResponse = await zoneamentoService.getZoneAvailability({
                cidade: reverse.cidade,
                estado: reverse.uf
            });
            let zoneAvailable = false;
            if (zoneamentoAvailableResponse.status === 200) {
                zoneAvailable = !!zoneamentoAvailableResponse.data.available;
            }

            await this.getKmlBairros(reverse.cidade, reverse.uf);

            let cidadeValue = {
                label: reverse.cidade, value: `${reverse.uf}-${reverse.cidade}`
            }


            let bairros = await this.fetchBairros(reverse.cidade);
            let newBairrosOptions = [...this.state.bairrosOptions, ...bairros];

            this.setState({
                ...this.state,
                cidade: [cidadeValue, ...this.state.cidade],
                estado: [reverse.uf, ...this.state.estado],
                bairrosOptions: newBairrosOptions,
                overlay_cidade: true,
                pontos: [...this.state.pontos, ponto],
                zoneamentoDisponivel: zoneAvailable,
            })

            await this.loadClusters();

            await this.reloadEmpreendimentos();
            document.querySelector('#search_box').value = '';

            await this.loadYearsOptionsForLinkagesDataLayer();

        } catch (error) {
            console.log(error);
        } finally {
            this.setState({
                ...this.state, loading: false
            });
        }


    }

    loadClusters = async () => {
        try {

            let cidades = this.state.cidade.map(c => c.label);
            let estados = this.state.estado;

            const clusters = await this.clusterService.getClusters(cidades, estados);


            await this.setState({
                ...this.state,
                opcoes_clustes: [...clusters],
            });

        } catch (error) {
            console.error("Erro ao buscar clusters da cidade:", error);
        }

    }

    handleChangedArray = async (e) => {
        if (e === null) {
            return this.setState({ ...this.state, regiao: [], });
        }

        let regiao = [];

        e.forEach((regiaoSelected) => {
            if (regiaoSelected.value === 'Todos') {
                return regiao = [
                    { value: "Sul", label: "Sul", },
                    { value: "Sudeste", label: "Sudeste", },
                    { value: "Nordeste", label: "Nordeste", },
                    { value: "Centro-Oeste", label: "Centro-Oeste", },
                    { value: "Norte", label: "Norte", }];
            }

            if (!regiao.includes(regiaoSelected)) {
                regiao.push(regiaoSelected);
            }
        })
        await this.setState({
            regiao: regiao,
            movimentar_mapa: true
        });

    };

    handleEstadosChangedInput = async (input) => {
        await this.setState({ inputEstadoValue: input });
    }

    handleBairroChangedInput = async (input) => {
        await this.setState({ inputBairroValue: input });
    }

    handleEstadosChanged = async (e) => {

        await this.setState({
            ...this.state,
            estadosSelecionados: e.value,
            estado: e.value
        })

        await this.centralizarMapaNaCapital(e);
    }

    centralizarMapaNaCapital = async () => {

        if (this.state.estadosSelecionados.length === 0 || this.state.estadosSelecionados.length > 1) {
            return;
        }

        try {
            //na busca pelo estado centraliza o mapa na capital do estado, para isso fazemos a busca dos dados da capital
            let response = await axios.get(route('state.capital', { state: this.state.estadosSelecionados[0] }));

            if (response.status !== 200) {
                return;
            }

            let coordinates = {
                lat: response.data.lat, lng: response.data.lng
            }

            window.googleMap.panTo(coordinates);
            window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(12);
        } catch (error) {
            console.log(error);
        }
    }

    /**
     * Handle Cidade Changed pelo campo do filtro onde os resultados não tem latitude e longitude
     */
    handleCidadeChangedOnFormFilter = async (cidadeOption) => {


        if (cidadeOption === null) {
            this.setState({
                ...this.state, cidade: [], estado: [], newBairrosOptions: []
            });

            return;
        }

        let estados = [];
        let cidades = [];
        let newBairrosOptions = [];

        for (let x = 0; x < cidadeOption.length; x++) {
            let option = cidadeOption[x];
            //alert( option );
            const cidadeParts = option.value.split('-');
            let estado = cidadeParts[0].trim();

            if (!cidades.includes(option)) {
                cidades.push(option);
            }

            if (!estados.includes(estado)) {
                estados.push(estado);
            }

            let bairros = await this.fetchBairros(option.label);


            newBairrosOptions = [...bairros, newBairrosOptions]
        }


        await this.setState({
            ...this.state,
            cidade: cidades,
            estado: estados,
            overlay_cidade: true,
            bairrosOptions: [...newBairrosOptions]
        });

        try {
            let cidade = this.state.cidade[this.state.cidade.length - 1].label;
            let estado = this.state.cidade[this.state.cidade.length - 1].value.split('-')[0];

            let address = `${cidade} ${estado} - Brasil`;

            let location = await geolocationService.location(address);

            window.googleMap.panTo({ lat: location.latitude, lng: location.longitude });

            await this.reloadEmpreendimentos();

            await this.loadClusters();

            await this.loadYearsOptionsForLinkagesDataLayer();

        } catch (error) {
            console.log(error);
        }

    }


    fetchBairros = async (cidade) => {
        try {
            let bairros = await axios.get('/bairros/json/' + cidade);

            return bairros.data;
        } catch (error) {
            console.log(error);
        }
    }

    onMarkerComplete = async (marker, map, circle) => {

        let color = this.getColor();
        let newCircle = new google.maps.Circle({
            ...defaultCircleOptions,
            center: marker.getPosition(),
            radius: 1000,
            fillColor: color,
            map: window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
        });

        newCircle.color = color;
        newCircle.type = 'Círculo';
        newCircle.id = this.generateRandomString();
        newCircle.name = this.state.circles.length + 1;

        google.maps.event.addListener(newCircle, 'radius_changed', (event) => {
            this.onCircleRadiusChanged(newCircle);
        });

        google.maps.event.addListener(newCircle, 'click', (event) => {
            this.editShapeName(newCircle);
        });


        await this.setState({
            ...this.state,
            circles: [newCircle, ...this.state.circles],
            overlays: [newCircle, ...this.state.overlays]
        });


        await this.reloadEmpreendimentos();

        if (this.state.kml_bairros.length > 0) {

            await this.setState({
                ...this.state, showKMl: false
            });

            //toggle
            if (this.state.kmls_to_show.length > 0) {
                this.cleanKmlLayers();
            }

            await this.loadKml();
        }
    }

    // onRectangleRadiusChanged = (rectangle) => {
    // }

    onCircleRadiusChanged = (circle) => {
        let newRadius = circle.getRadius();

        this.setState({
            showTooltip: true, radiusChanging: newRadius
        });

        setTimeout(() => {
            this.setState({
                showTooltip: false,
            })
        }, 1000)

        this.reloadEmpreendimentos();

    }

    removeOverlay = async (id) => {

        let overlays = this.state.overlays;
        let circles = this.state.circles;
        let poligonos = this.state.polygons;
        let countPolygons = this.state.countPolygons;
        let countRectangles = this.state.countRectangles;

        let index = overlays.findIndex((overlay) => {
            return overlay.id === id
        });

        let overlay = overlays[index];


        if (overlay.type === 'Retângulo' || overlay.type === 'Polígono') {
            let indexPoligono = poligonos.findIndex((overlay) => {
                return overlay.id === id
            });
            poligonos.splice(indexPoligono, 1);
            overlay.setMap(null);

            if (overlay.type === 'Retângulo') {
                countRectangles--;
            } else {
                countPolygons--;
            }
        }

        if (overlay.type === 'Círculo' || overlay.type === 'Círculo Manual') {
            let indexCircle = circles.findIndex((overlay) => {
                return overlay.id === id
            });
            circles.splice(indexCircle, 1);


            if (overlay.setMap !== undefined) {
                overlay.setMap(null);
            }

        }

        overlays.splice(index, 1);


        await this.setState({
            overlays: [...overlays],
            manualCircles: [...circles],
            polygons: [...poligonos],
            countPolygons: countPolygons,
            countRectangles: countRectangles
        });

        if (this.state.empreendimentos.length > 0) {
            await this.reloadEmpreendimentos();
        }

    }

    handleShowInfoWindow = () => {
        this.setState({
            showInfoWindow: true
        });
    }

    handleHideInfoWindow = () => {
        this.setState({
            showInfoWindow: false
        });
    }

    getColor = () => {
        return colors[this.state.overlays.length];
    }

    resetMarkers = async () => {
        let newEmpreendimentos = [];

        await this.state.empreendimentos.map((empreendimento) => {

            empreendimento.customMarker = undefined;
            newEmpreendimentos.push(empreendimento);

        });

        this.mapBuilding(newEmpreendimentos);

        this.setState({
            ...this.state, empreendimentos: newEmpreendimentos
        });

    }
    resetRevendaMarkers = async () => {
        let newRevenda = [];

        this.state.revendaLocacao.map((empreendimento) => {
            empreendimento.customMarker = undefined;
            newRevenda.push(empreendimento);
        });

        this.mapBuilding(newRevenda);

        this.setState({
            ...this.state, revendaLocacao: newRevenda
        });

    }

    replaceRevendaMarkers = async () => {

        await this.resetRevendaMarkers();

        let newRevenda = await replaceMarkersRevendaLocacao(this.state.revendaLocacao);

        this.setState({
            ...this.state, revendaLocacao: newRevenda,
        });
    };

    //replace markers with markers from ranges
    replaceMarkers = async () => {
        //reload para para resetar os marcadores
        await this.resetMarkers();

        if (this.state.ranges.length > 0) {
            let ranges = this.state.ranges;

            let newEmpreendimentos = [];

            await this.state.empreendimentos.map((empreendimento) => {

                let range = ranges.find((range) => {

                    if (range.type === 'padroes') {
                        return range.padroes.includes(empreendimento.padrao);
                    }

                    return (empreendimento[range.type] >= range.min && empreendimento[range.type] <= range.max);
                });


                if (range !== undefined) {

                    if (range.marker.type === 'image') {
                        empreendimento.customMarker = range.marker.value;
                    } else {
                        empreendimento.customMarker = range.marker;
                    }

                }

                newEmpreendimentos.push(empreendimento);

            });

            this.setState({
                ...this.state,
                empreendimentos: newEmpreendimentos
            });

        }

    }

    addRange = async (range) => {
        await this.setState({
            ...this.state, ranges: [...this.state.ranges, range]
        });
    }
    updateRange = async (range) => {
        this.setState({
            ...this.state,
            ranges: this.state.ranges.map((r) =>
                r.id === range.id ? { ...r, ...range } : r
            ),
        });

    };


    removeRange = async (range) => {
        this.setState({
            ...this.state, ranges: this.state.ranges.filter(r => r.id !== range.id)
        });
    }

    handleCloseModalInfo = async () => {
        await this.setState({
            ...this.state, showInfo: false
        });
        $("#btn-results").click();
    };

    handleCloseProjectName = async () => {
        await this.setState({
            ...this.state, showProjectName: false
        });
    };

    openModalWork = async () => {
        await this.setState({
            ...this.state,
            showProjectName: true,
            left_side_bar_visible: false,
        });

        $("#btn-results").click();

    };

    closeAndAlterStatusBuilding = async () => {

        let data = this.state.empreendimentosDoMes;
        let url = window.location + `/show-new-buildings-map`;

        const headers = new Headers();
        const token = document.head.querySelector('meta[name="csrf-token"]').content;

        headers.append("X-CSRF-TOKEN", token);
        headers.append("Content-Type", "application/json");

        fetch(url, {
            method: "POST", body: JSON.stringify(data), headers: headers, credentials: "same-origin"
        })
            .then(response => response.json())
            .then(async data => {
                if (data.success == true) {
                    await this.setState({
                        ...this.state, showInfo: false
                    });
                    $("#btn-results").click();
                }
            });
    };

    /**
     * Mapeia Empreendimentos recém lançados
     * @param buildings
     * @returns {Promise<void>}
     */
    mapBuilding = async (buildings) => {

        let buildingsFromThisMonth = []
        let buildingsFiltred = [];
        let userBuildingsRejected = await axios.get(route('show-new-buildings-map', { building: this.props.building_id }));
        buildings.filter((building) => {
            if (building.data_lancamento > moment().subtract(2, 'months').clone().startOf("month").format()) {
                buildingsFromThisMonth.push(building);
            }
        });

        buildingsFromThisMonth.filter((building) => {
            if (userBuildingsRejected.data.buildings.includes(building._id) === false) {
                buildingsFiltred.push(building);
            }
        })

        if (buildingsFiltred.length > 0) {
            await this.setState({
                ...this.state, empreendimentosDoMes: buildingsFiltred, showInfo: true,
            });
            $(".p-sidebar-close").click();

            $("#btn-results").click();
        }
    }

    closeModalEmpreendimento = async () => {

        await this.setState({
            ...this.state, modal_empreendimento_visible: false, currentShowing: undefined
        });
        document.getElementById("btn-results").click();


    };

    setPolosGeradoresCurrentShowing = async (polos, polosAgrupados, cacheKey) => {

        await this.setState({
            ...this.state,
            polos_geradores_current_showing: polos,
            polos_geradores_current_grouped: polosAgrupados,
            polos_geradores_current_cache_key: cacheKey,
            show_modal_polos_geradores: true
        });

        await this.comparaPolosOnArea();

    }

    closeModalDadosSocioDemografia = async () => {
        await this.setState({
            ...this.state, show_modal_dados_socio_demografia: false
        });
    }

    loadDadosSensoDemografico = async (requestConfig) => {

        let tipoInformacao = requestConfig.tipoInformacao;

        try {
            let { polygons, cidades, hash } = this.getTransformedPayloadForSenso();

            if (this.state.dados_senso_demografico?.[hash] && this.state.dados_senso_demografico?.[hash]?.[tipoInformacao]) {
                return this.state.dados_senso_demografico?.[hash]?.[tipoInformacao];
            }

            await this.setState({
                ...this.state, loading_dados_socio_demografia: true
            });

            if (tipoInformacao === 'faixa_etaria') {

                let dataFaixaEtaria = await this.loadFaixasEtarias(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            faixa_etaria: dataFaixaEtaria
                        }
                    }
                });

                return dataFaixaEtaria;
            }

            if (tipoInformacao === 'faixa_etaria2022') {
                debugger;

                let dataFaixaEtaria = await this.loadFaixasEtarias2022(polygons, cidades);


                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            faixa_etaria2022: dataFaixaEtaria
                        }
                    }
                });

                return dataFaixaEtaria;
            }

            if (tipoInformacao === 'domicilios_por_tipo_moradia' || tipoInformacao === 'indice_verticalizacao') {
                let dataDomiciliosPorTipo = await this.loadDomiciliosPorTipo(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            domicilios_tipo: dataDomiciliosPorTipo
                        }
                    }
                });

                return dataDomiciliosPorTipo;

            }

            if (tipoInformacao === 'domicilios_por_tipo_moradia2022' || tipoInformacao === 'indice_verticalizacao2022') {

                let dataDomiciliosPorTipo = await this.loadDomiciliosPorTipo2022(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            [tipoInformacao]: dataDomiciliosPorTipo
                        }
                    }
                });

                return dataDomiciliosPorTipo;

            }

            if (tipoInformacao === 'domicilios_por_condicao_ocupacao') {
                let data = await this.loadDomiciliosPorOcupacao(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            domicilio_por_ocupacao: data
                        }
                    }
                });

                return data;
            }

            if (tipoInformacao === 'domicilios_por_tipo_moradia_simplificado') {
                let data = await this.loadDomiciliosPorTipoMoradiaSimplificado(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            domicilios_tipo_simplificado: data
                        }
                    }
                });

                return data;
            }

            if (tipoInformacao === 'domicilios_por_numero_moradores') {


                let data = await this.loadDomiciliosPorNumeroMoradores(polygons, cidades, requestConfig.ranges);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            domicilio_por_numero_moradores: data
                        }
                    }
                });

                return data;
            }

            if (tipoInformacao === 'domicilios_por_numero_moradores2022') {


                let data = await this.loadDomiciliosPorNumeroMoradores2022(polygons, cidades, requestConfig.ranges);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            domicilio_por_numero_moradores: data
                        }
                    }
                });

                return data;
            }

            if (tipoInformacao === 'domicilios_por_faixa_de_renda') {
                let data = await this.loadDomiciliosPorFaixaDeRenda(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            domicilios_por_faixa_de_renda: data
                        }
                    }
                });

                return data;
            }

            if (tipoInformacao === 'populacao_por_faixa_de_renda') {
                let data = await this.loadPopulacaoPorFaixaDeRenda(polygons, cidades);

                await this.setState({
                    ...this.state,
                    dados_senso_demografico: {
                        ...this.state.dados_senso_demografico,
                        [hash]: {
                            ...this.state.dados_senso_demografico?.[hash],
                            populacao_por_faixa_de_renda: data
                        }
                    }
                });

                return data;
            }

        } catch (e) {
            console.log(e);
        } finally {
            await this.setState({
                ...this.state, loading_dados_socio_demografia: false
            });
        }
    }

    loadDomiciliosPorOcupacao = async (polygons, cidades) => {
        try {
            // Usa o endpoint dedicado (linkage) com as colunas consolidadas de 2022,
            // para bater com a tabela de Domicílios por Condição de Ocupação.
            const response = await LinkagesDataLayerService.getCondicaoOcupacao({ poligonos: polygons, cidades });
            return (response.data || []).map(item => ({
                ...item,
                proprios: (Number(item.proprio_quitado) || 0) + (Number(item.proprio_financiado) || 0),
                alugados: Number(item.alugado) || 0,
                cedidos: Number(item.cedido_ou_emprestado) || 0,
                outra_condicao: Number(item.outras_condicoes) || 0,
            }));
        } catch (e) {
            throw e;
        }
    }

    loadDomiciliosPorTipoMoradiaSimplificado = async (polygons, cidades) => {
        try {
            // Endpoint dedicado (linkage) já retorna casa/apartamento/outros_tipos de 2022.
            const response = await LinkagesDataLayerService.getTipoMoradia({ poligonos: polygons, cidades });
            return response.data;
        } catch (e) {
            throw e;
        }
    }

    loadDomiciliosPorTipo = async (polygons, cidades) => {
        try {
            return await getDomiciliosPorTipo(polygons, cidades);
        } catch (e) {
            throw e;
        }
    }

    loadDomiciliosPorTipo2022 = async (polygons, cidades) => {
        try {
            return await getDomiciliosPorTipo2022(polygons, cidades);
        } catch (e) {
            throw e;
        }
    }

    loadDomiciliosPorNumeroMoradores = async (polygons, cidades, ranges) => {
        try {
            return await getDomiciliosPorNumeroMoradores(polygons, cidades, ranges);
        } catch (e) {
            throw e;
        }
    }

    loadDomiciliosPorNumeroMoradores2022 = async (polygons, cidades, ranges) => {
        try {
            return await getDomiciliosPorNumeroMoradores2022(polygons, cidades, ranges);
        } catch (e) {
            throw e;
        }
    }

    loadDomiciliosPorFaixaDeRenda = async (polygons, cidades) => {
        try {
            return await getDomiciliosPorFaixaDeRenda(polygons, cidades);
        } catch (e) {
            throw e;
        }
    }

    loadPopulacaoPorFaixaDeRenda = async (polygons, cidades) => {
        try {
            return await getPopulacaoPorFaixaDeRenda(polygons, cidades);
        } catch (e) {
            throw e;
        }
    }

    loadFaixasEtarias = async (polygons, cidades) => {
        try {
            return await getFaixasEtarias(polygons, cidades);
        } catch (e) {
            throw e;
        }
    }

    loadFaixasEtarias2022 = async (polygons, cidades) => {
        try {
            return await getFaixasEtarias2022(polygons, cidades);
        } catch (e) {
            throw e;
        }
    }

    loadMapaCloropetico = async (tipoMapa) => {
        try {
            const tiposValidos = Object.keys(configSociodemografia).filter(tipo => tipo.startsWith("mapa_coropetico"));

            if (!tiposValidos.includes(tipoMapa)) {
                throw new Error("Tipo de Mapa Inválido");
            }

            await this.setState({
                ...this.state, loading: true
            });

            let configOptions = configSociodemografia[tipoMapa];

            let { polygons, cidades } = this.getTransformedPayloadForSenso();

            let data = [];

            if (tipoMapa === "mapa_coropetico_renda_domiciliar") {
                data = await getSetoresWithHouldhouseIncome(
                    polygons, cidades, configOptions.color_ranges, configOptions.dado_range
                );
            }

            if (tipoMapa === "mapa_coropetico_indice_verticalizacao") {
                data = await getSetoresWithVerticalizationIndex(
                    polygons, cidades, configOptions.color_ranges, configOptions.dado_range
                );
            }

            if (tipoMapa === "mapa_coropetico_indice_verticalizacao2022") {
                data = await getSetoresWithVerticalizationIndex2022(
                    cidades, configOptions.color_ranges, configOptions.dado_range
                );
            }

            if (tipoMapa === "mapa_coropetico_indice_propriedade") {
                data = await getSetoresWithPropertyIndex(
                    polygons, cidades, configOptions.color_ranges, configOptions.dado_range
                );
            }

            if (tipoMapa === 'mapa_coropetico_densidade_demografica_2010') {
                data = await getSetoresWithPopulationDensity(
                    polygons, cidades, configOptions.color_ranges, configOptions.dado_range
                );
            }

            if (tipoMapa === 'mapa_coropetico_densidade_demografica_2022') {
                data = await getSetoresWithPopulationDensityCenso2022(
                    polygons, cidades, configOptions.color_ranges, configOptions.dado_range
                );
            }

            if (!data || data.length === 0) {
                toast.warn("Nenhum resultado encontrado para a camada de sociodemografia selecionada.", {
                    position: "top-center",
                    autoClose: 5000,
                });
                return;
            }

            this.setState({
                ...this.state,
                mapa_coropetico_current_showing: {
                    config: configOptions,
                    data: data,
                    type: tipoMapa
                },
                color_ranges: {
                    ...this.state.color_ranges,
                    [tipoMapa]: configOptions.color_ranges
                }
            });

            await this.showIbgeInfo(tipoMapa, data);

        } catch (e) {
            console.log(e);
        } finally {
            await this.setState({
                ...this.state, loading: false
            });
        }
    }

    openModalDadosSocioDemograficos = async () => {
        $("#btn-results").click();

        await this.setState({
            ...this.state, show_modal_dados_socio_demografia: true,
            left_side_bar_visible: false
        });
    }

    closeModalMapCapture = () => {
        this.setState({
            ...this.state,
            show_modal_map_screen_capture: false
        });

    }

    centralizarMapaNaForma = async (formaId) => {

        const overlay = this.state.overlays.find((overlay) => overlay.id === formaId);

        if (!overlay) {
            return;
        }

        if (overlay.type === 'Polígono') {
            this.fitBounds(await this.getPolygonBounds(overlay));
        }

        if (overlay.type === 'Círculo' || overlay.type === 'Círculo Manual' || overlay.type === 'Retângulo') {
            this.fitBounds(overlay.getBounds());
        }


    }

    showRangesModal = () => {
        this.setState({ modalRangesOpen: true, });
        $(".p-sidebar-close").click();
        $("#btn-results").click();
    };

    showHeatMapModal = () => {
        this.setState({ modalHeatMapOpen: true, });
        $(".p-sidebar-close").click();
        $("#btn-results").click();
    };

    onChangeDatalayerName = async (event) => {

        const datalayerType = event.target.value;

        const mapColorPropertiesOptions = LinkagesDataLayerService.getOptionsForColorMap(datalayerType);

        await this.setState({
            ...this.state,
            datalayerName: datalayerType,
            datalayerFriendlyName: LinkagesDataLayerService.getLayerLabel(datalayerType),
            datalayerColorProperty: null,
            datalayerColorPropertyOptions: mapColorPropertiesOptions
        });

        //Os temas abaixo não precisam de nenhuma outra informação para exibição
        const loadDirect = [
            'dutovias',
            'vazios_urbanos',
            'area_preservacao',
            'area_urbanizada',
            'indicadores_municipio'
        ];

        if (loadDirect.includes(datalayerType)) {
            await this.loadDataLayer();
        }
    }

    onChangeDatalayerColorProperty = async (event) => {

        await this.setState({
            ...this.state,
            datalayerColorProperty: event.value
        });

        const loadDirect = ['renda', 'consumo_valor', 'consumo_porcentagem', 'populacao', 'domicilios', 'indice_propriedade'];

        if (loadDirect.includes(this.state.datalayerName)) {
            await this.loadDataLayer();
        }
    }

    onChangeDatalayerYear = async (event) => {
        await this.setState({
            ...this.state,
            datalayerYear: event.value
        });

        await this.loadDataLayer();
    }

    onChangeDatalayerYears = async (event) => {
        await this.setState({
            ...this.state,
            datalayerYears: event.value,
            datalayerColorProperty: 'ano'
        });
    }

    onChangeOpacidadePreenchimento = (e, newValue) => {
        this.setState({
            ...this.state,
            datalayerFillOpacity: newValue
        });
    }

    setDrawing = async (drawing) => {
        await this.setState({
            ...this.state,
            isDrawing: drawing,
            showMarkers: !drawing,
        });
    }

    render() {

        var data_lancamento_inicial = "";
        var data_lancamento_final = "";

        if (this.state.empreendimentosDoMes.length) {
            let empreendimentosOrdenados = this.state.empreendimentosDoMes.sort((a, b) => {
                // Converta as datas para objetos Date para comparação
                let dataA = new Date(a.data_lancamento);
                let dataB = new Date(b.data_lancamento);

                return dataA - dataB;
            });

            data_lancamento_inicial = empreendimentosOrdenados[0].data_lancamento
            data_lancamento_final = empreendimentosOrdenados[empreendimentosOrdenados.length - 1].data_lancamento
        }


        return (<>
            {this.state.loading && <Loader />}

            <MapCapture
                visible={this.state.show_modal_map_screen_capture}
                handleClose={this.closeModalMapCapture}
                imageData={this.state.mapScreenCaptureData}
                canvas={this.state.canvas}
            />

            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ width: "60%", color: "#000", zIndex: 9999999 }}
            />

            <ModalPolosGeradores
                handleCloseModal={this.closeModalPolosGeradores}
                show={this.state.show_modal_polos_geradores}
                polos={this.state.polos_geradores_current_showing}
                polos_geradores_agrupados={this.state.polos_geradores_current_grouped}
                cacheKey={this.state.polos_geradores_current_cache_key}
            />

            <SocioDemografiaModal
                show={this.state.show_modal_dados_socio_demografia}
                handleClose={this.closeModalDadosSocioDemografia}
                data={this.state.faixa_etaria_data}
                overlays={this.state.overlays}
                loading={this.state.loading_dados_socio_demografia}
                loadDadosSensoDemografico={this.loadDadosSensoDemografico}
                loadMapaCloropetico={this.loadMapaCloropetico}
            />

            {
                this.state.show_modal_datalayer_datatable && <React.Fragment>
                    <LinkagesDataTableModal
                        visible={this.state.show_modal_datalayer_datatable}
                        onHide={this.closeModalDatalayerTable}
                        activeDatalayer={this.state.datalayerName}
                        overlays={this.state.overlays}
                        data={this.state.datalayers_table_data}
                        getTransformedPayload={() => this.getTransformedPayloadForSenso()}
                    />
                </React.Fragment>
            }

            <ModalRaioPorDeslocamento
                show={this.state.show_modal_raio_de_deslocamento}
                handleClose={this.closeModalDeslocamento}
                loading={false}
                center={this.state.marker_deslocamento_position}
                onPolygonComplete={this.onPolygonComplete}
            />

            <AlertModal
                show={this.state.showInfo}
                handleClose={this.handleCloseModalInfo}
                closeAndAlterStatusBuilding={this.closeAndAlterStatusBuilding}
            >
                <div className="row">
                    <div className="col-md-12">
                        <p className="alert alert-secondary text-justify font-weight-bold">
                            {data_lancamento_inicial !== data_lancamento_final && <>
                                Aqui estão os empreendimentos lançados entre{" "}
                                {new Date(data_lancamento_inicial).toLocaleDateString("pt-BR", {
                                    year: 'numeric',
                                    month: '2-digit'
                                })}{" "}
                                até {new Date(data_lancamento_final).toLocaleDateString("pt-BR", {
                                    year: 'numeric',
                                    month: '2-digit'
                                })}.
                            </>}

                            {data_lancamento_inicial === data_lancamento_final && <>
                                Aqui estão os empreendimentos lançados em{" "}
                                {new Date(data_lancamento_inicial).toLocaleDateString("pt-BR", {
                                    year: 'numeric',
                                    month: '2-digit'
                                })}{" "}
                            </>}

                        </p>
                    </div>
                    <div className="col-md-12">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Data</th>
                                    <th scope="col">Nome</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.empreendimentosDoMes.map((empreendimento, index) => {
                                    return (<tr key={`emp-mes-${index}`}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {new Date(empreendimento.data_lancamento).toLocaleDateString("pt-BR", {
                                                year: 'numeric',
                                                month: '2-digit'
                                            })}
                                        </td>
                                        <td>
                                            {empreendimento.nome}
                                        </td>
                                    </tr>);
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </AlertModal>

            <ModalSalvarProjeto
                show={this.state.showProjectName}
                handleClose={this.handleCloseProjectName}
                handleNameProjectChanged={this.handleNameProjectChanged}
                project_name={this.state.project_name}
                saveProject={this.saveProject}
                loading={this.state.loadingSaveProject}
                share_users={this.state.project_share_users}
                handleShareUsersChanged={this.handleShareUsersChanged}
                errors={this.state.errors_projeto}
            />

            <ModalLegendaRendaIbge
                show={this.state.show_modal_customizar_cores_setores}
                handleClose={this.closeModalLegendaSetores}
                colorRanges={this.state.color_ranges[this.getColorRangeKey()]}
                updateRange={this.updateRendaColorRange}
                replaceRanges={this.replaceColorRanges}
                removeRange={this.removeRendaColorRange}
                handleAplyColorRanges={this.handleAplyColorRanges}
                colorOptions={this.state.colorsOptions}
                datalayerName={this.state.datalayerFriendlyName}
                datalayerColorProperty={this.state.datalayerColorProperty}
                datalayerFillOpacity={this.state.datalayerFillOpacity}
                onChangeOpacidadePreenchimento={this.onChangeOpacidadePreenchimento}
            />

            {
                this.state.current_shape_editing !== null &&
                <ShapesAttributesEditor
                    show={this.state.show_modal_change_shape_attributes}
                    shape={this.state.current_shape_editing}
                    onHide={() => {
                        this.setState({
                            ...this.state,
                            show_modal_change_shape_attributes: false
                        });
                    }}
                    updateShape={this.updateShape}
                />
            }


            {
                !this.state.left_side_bar_visible && <>
                    <div className="map-sidebar-show-button-wrapper">
                        <button
                            title="Mostrar Barra Lateral"
                            onClick={() => { this.setState({ left_side_bar_visible: true }); ClusterService.updateLegendaPosition(true); }}
                            className="btn btn-primary btn-show-map-sidebar">
                            <i className="fas fa-angle-double-right"></i>
                        </button>
                    </div>
                </>
            }

            <ModalRanges
                show={this.state.modalRangesOpen}
                ranges={this.state.ranges}
                closeModal={() => this.setState({ modalRangesOpen: false })}
                addRange={this.addRange}
                updateRange={this.updateRange}
                removeRange={this.removeRange}
                replaceMarkers={this.replaceMarkers}
            ></ModalRanges>

            <ModalHeatMap
                show={this.state.modalHeatMapOpen}
                closeModal={() => this.setState({ modalHeatMapOpen: false })}
                addHeatMap={this.addHeatMap}
            />

            <Sidebar visible={this.state.left_side_bar_visible}
                onHide={() => {
                    this.setState({ left_side_bar_visible: false });
                    ClusterService.updateLegendaPosition(false);
                }}
            >
                <Tabs
                    activeKey={this.state.active_tab}
                    defaultActiveKey="filtros"
                    onSelect={(e) => {
                        this.setState({
                            ...this.state, active_tab: e
                        })
                    }}
                    id="uncontrolled-tab-example">
                    <Tab eventKey="filtros" title="Filtros">
                        <FormFilters
                            clearDefaultEmpreendimentos={this.clearDefaultEmpreendimentos}
                            buscaEmpreendimentossDefaultOptions={this.state.buscaEmpreendimentossDefaultOptions}
                            inputEstadoValue={this.state.inputEstadoValue}
                            inputBairroValue={this.state.inputBairroValue}
                            handleCidadeChanged={this.handleCidadeChangedOnFormFilter}
                            handleAreaMaximaChanged={this.handleAreaMaximaChanged}
                            handleAreaMinimaChanged={this.handleAreaMinimaChanged}
                            handlePadraoChanged={this.handlePadraoChanged}
                            handleProjetoChanged={this.handleProjetoChanged}
                            handleValorMinimoChanged={this.handleValorMinimoChanged}
                            handleValorMaximoChanged={this.handleValorMaximoChanged}
                            handleValorMetroMinimoChanged={this.handleValorMetroMinimoChanged}
                            handleValorMetroMaximoChanged={this.handleValorMetroMaximoChanged}
                            handleTipoEmpreendimentoChanged={this.handleTipoEmpreendimentoChanged}
                            handleIncluirMonitoradasChanged={this.handleIncluirMonitoradasChanged}
                            check_incluir_monitoradas={this.state.check_incluir_monitoradas}
                            handleStatusChanged={this.handleStatusChanged}
                            handleRetrofitChanged={this.handleRetrofitChanged}
                            handleTipoChanged={this.handleTipoChanged}
                            getPadroes={this.getPadroes}
                            getProjects={this.getProjects}
                            bairrosOptions={this.state.bairrosOptions}
                            bairros={this.state.bairros}
                            handleBairrosChanged={this.handleBairrosChanged}
                            handleRaioChanged={this.handleRaioChanged}
                            tipo_empreendimento={this.state.tipo_empreendimento}
                            handleSubmit={this.reloadEmpreendimentos}
                            cleanState={this.cleanState}
                            handleQuartosChanged={this.handleQuartosChanged}
                            handleVagasChanged={this.handleVagasChanged}
                            quartos={this.state.quartos}
                            vagas={this.state.vagas}
                            retrofit={this.state.retrofit}
                            area_minima={this.state.area_maior_que}
                            area_maxima={this.state.area_menor_que}
                            status={this.state.status}
                            tipo_negocio={this.state.tipo_negocio}
                            padrao={this.state.padrao}
                            projetos={this.state.projetos}
                            projeto={this.state.projeto}
                            raio={this.state.raio}
                            handleIncorporadoraChanged={this.handleIncorporadoraChanged}
                            address={this.state.address}
                            valor_parcela_minima={this.state.valor_parcela_minima}
                            valor_parcela_maxima={this.state.valor_parcela_maxima}
                            valor_maior_que={this.state.valor_maior_que}
                            valor_menor_que={this.state.valor_menor_que}
                            valor_metro_menor_que={this.state.valor_metro_menor_que}
                            valor_metro_maior_que={this.state.valor_metro_maior_que}
                            showLegenda={this.state.empreendimentos.length > 0}
                            handleAnoLancamentoChanged={this.handleAnoLancamentoChanged}
                            handleMesAnoLancamentoChanged={this.handleMesAnoLancamentoChanged}
                            handleEstagioChanged={this.handleEstagioChanged}
                            mes_ano_lancamento={this.state.mes_ano_lancamento}
                            ano_lancamento={this.state.ano_lancamento}
                            estagio={this.state.estagio}
                            handleNomeEmpreendimentoChanged={this.handleNomeEmpreendimentoChanged}
                            nome_empreendimento={this.state.nome_empreendimento}
                            searchEmpreendimentos={this.searchEmpreendimentos}
                            overlays={this.state.overlays}
                            cidade={this.state.cidade}
                            incorporators={this.state.incorporadoras}
                            downloadKml={this.downloadKml}
                            openModalWork={this.openModalWork}
                            handleJurosMinimoChanged={this.handleJurosMinimoChanged}
                            handleJurosMaximoChanged={this.handleJurosMaximoChanged}
                            handleParcelasMinimoChanged={this.handleParcelasMinimoChanged}
                            handleParcelasMaximoChanged={this.handleParcelasMaximoChanged}
                            handleValorParcelaMinimaChanged={this.handleValorParcelaMinimaChanged}
                            handleValorParcelaMaximaChanged={this.handleValorParcelaMaximaChanged}
                            juros_maximo={this.state.juros_maximo}
                            juros_minimo={this.state.juros_minimo}
                            parcelas_maximo={this.state.parcelas_maximo}
                            parcelas_minimo={this.state.parcelas_minimo}
                            valor_parcela_maximo={this.state.valor_parcela_maximo}
                            valor_parcela_minimo={this.state.valor_parcela_minimo}
                            ranges={this.state.ranges}
                            open_modal_polos_geradores={this.openModalPolosGeradores}
                            setShowPolosGeradores={this.setShowPolosGeradores}
                            showPolosGeradores={this.state.show_polos_geradores}
                            showMarkers={this.state.showMarkers}
                            setShowMarkers={this.setShowMarkers}
                            showResaleOrLocationMarkers={this.state.showResaleOrLocationMarkers}
                            polos_geradores_types_selected={this.state.polos_geradores_types_selected}
                            setPolosGeradoresTypes={this.setPolosGeradoresTypes}
                            estadosSelecionados={this.state.estadosSelecionados}
                            handleEstadosChanged={this.handleEstadosChanged}
                            handleEstadosChangedInput={this.handleEstadosChangedInput}
                            handleBairroChangedInput={this.handleBairroChangedInput}
                            handleChangedArray={this.handleChangedArray}
                            regiao={this.state.regiao}
                            busca_por_estado={this.state.busca_por_estado}
                            setBuscaPorEstado={this.setBuscaPorEstado}
                            handlePorcentagemVendidaMaximaChanged={this.handlePorcentagemVendidaMaximaChanged}
                            handlePorcentagemVendidaMinimaChanged={this.handlePorcentagemVendidaMinimaChanged}
                            porcentagem_vendida_minima={this.state.porcentagem_vendida_minima}
                            porcentagem_vendida_maxima={this.state.porcentagem_vendida_maxima}
                            toggleUseCluster={this.toggleUseCluster}
                            use_cluster={this.state.use_cluster}
                            opcoes_clustes={this.state.opcoes_clustes}
                            handleClusterChanged={this.handleClusterChanged}
                            cluster={this.state.cluster}
                            handleRegiaoChanged={this.handleRegiaoChanged}
                        />

                    </Tab>
                    <Tab eventKey="ferramentas" title="Ferramentas">
                        <Ferramentas
                            setShowPolosGeradores={this.setShowPolosGeradores}
                            showPolosGeradores={this.state.show_polos_geradores}
                            handleIncluirMonitoradasChanged={this.handleIncluirMonitoradasChanged}
                            check_incluir_monitoradas={this.state.check_incluir_monitoradas}

                            onChangeInputRadius={this.onChangeInputRadius}
                            removeOverlay={this.removeOverlay}
                            editShapeName={this.editShapeName}
                            removeHeatMap={this.removeHeatMap}
                            heatMap={this.state.heatMap}
                            showMarkers={this.state.showMarkers}
                            toggleShowMarkers={this.toggleShowMarkers}
                            overlays={this.state.overlays}
                            toogleOverlayVisibility={this.toogleOverlayVisibility}
                            reloadEmpreendimentos={this.reloadEmpreendimentos}
                            removeIbgeDataLayer={this.removeIbgeDataLayer}
                            toggleIbgeDataLayerVisibility={this.toggleIbgeDataLayerVisibility}
                            ibgeDataLayer={this.state.ibgeDataLayer}
                            polos_geradores_types_selected={this.state.polos_geradores_types_selected}
                            removePolosGeradoresTypeSelectedAndReloadEmpreendimentos={this.removePolosGeradoresTypeSelectedAndReloadEmpreendimentos}
                            createAndAddPolygon={this.createAndAddPolygon}
                            downloadKml={this.downloadKml}
                            setShowMarkers={this.setShowMarkers}
                            toggleUseCluster={this.toggleUseCluster}
                            use_cluster={this.state.use_cluster}
                            openModalWork={this.openModalWork}
                            toggleShowZoneamento={this.toggleShowZoneamento}
                            zoneamentoDisponivel={this.state.zoneamentoDisponivel}
                            show_zoneamento={this.state.show_zoneamento}
                            valores_propriedades_zoneamento={this.state.valores_propriedades_zoneamento}
                            opcoes_propriedades_zoneamento={this.state.opcoes_propriedades_zoneamento}
                            handleFiltrarZoneamento={this.handleFiltrarZoneamento}
                            setLoadingKml={this.setLoadingKml}
                            centralizarMapaNaForma={this.centralizarMapaNaForma}
                            projeto={this.state.projeto}
                            deleteProject={this.deleteProject}
                            printMap={this.printMap}
                            showKMl={this.state.showKMl}
                            showKmlBairros={this.showKmlBairros}
                            kml_bairros={this.state.kml_bairros}
                            loadDataLayer={this.loadDataLayer}
                            datalayerName={this.state.datalayerName}
                            datalayerColorProperty={this.state.datalayerColorProperty}
                            datalayerColorPropertyOptions={this.state.datalayerColorPropertyOptions}
                            cidades={this.state.cidade}
                            setShowResaleMarkers={this.setShowResaleMarkers}
                            setShowLocationMarkers={this.setShowLocationMarkers}
                            showResaleMarkers={this.state.showResaleMarkers}
                            showLocationMarkers={this.state.showLocationMarkers}
                            showRangesModal={this.showRangesModal}
                            showHeatMapModal={this.showHeatMapModal}
                            openModalDadosSocioDemograficos={this.openModalDadosSocioDemograficos}
                            onChangeDatalayerName={this.onChangeDatalayerName}
                            onChangeDatalayerColorProperty={this.onChangeDatalayerColorProperty}
                            datalayerYear={this.state.datalayerYear}
                            datalayerYears={this.state.datalayerYears}
                            datalayerYearOptions={this.state.datalayerYearOptions}
                            onChangeDatalayerYear={this.onChangeDatalayerYear}
                            onChangeDatalayerYears={this.onChangeDatalayerYears}
                            setDemarcacaoAreas={this.setDemarcacaoAreas}
                            show_demarcacao_areas={this.state.show_demarcacao_areas}
                            loadDataLayerAggregated={this.loadDataLayerAggregated}
                            show_modal_datalayer_datatable={this.state.show_modal_datalayer_datatable}
                            closeModalDatalayerTable={this.closeModalDatalayerTable}
                        />
                    </Tab>
                    <Tab eventKey="legendas" title="Legenda">
                        <div className="card-body" style={{ height: '75vh', overflowY: 'auto' }} id="legendas-container">

                            {this.state.show_zoneamento && <LegendaDataLayer legendas={this.state.legenda_zoneamento} />}

                            {this.state.showLegendaRenda && <React.Fragment>
                                <RendaIbgeLegend
                                    openModalLegendas={this.openModalLegendaSetores}
                                    colorRanges={this.state.color_ranges[this.getColorRangeKey()]}
                                    title={this.state.datalayerFriendlyName}
                                    datalayerName={this.state.datalayerName}
                                    datalayerColorProperty={this.state.datalayerColorProperty}
                                    mapa_coropetico_current_showing={this.state.mapa_coropetico_current_showing}
                                />
                                &nbsp;

                            </React.Fragment>}

                            {this.state.heatMap && <>
                                <HeatMapLegend
                                    weightType={this.state.heatMapWeightType}
                                    gradient={this.getGradientConfig()}
                                    min={this.state.minIntensity}
                                    max={this.state.maxIntensity}
                                    medium={this.state.medianIntensity}
                                    config={this.state.heatMapLegendConfig}
                                    legend={this.state.heatMapLegendConfig.legend}
                                />
                            </>}
                            {this.state.empreendimentos.length > 0 && this.state.showMarkers && (<Legenda ranges={this.state.ranges} />)}
                            {this.state.polos_geradores.length > 0 && this.state.show_polos_geradores && (<LegendaPoloGerador />)}
                        </div >

                    </Tab >
                </Tabs >
            </Sidebar >

            <div className="col-12" id="content" style={{ position: "relative" }}>
                {(this.state.empreendimentos.length || this.state.polos_geradores.length) > 0 && (
                    <SlidingPaneEmpreendimento
                        setLoading={this.setLoading}
                        closePane={this.closePane}
                        loadingMetadata={this.state.loadingMetadata}
                        isOpen={this.state.isSlideOpen}
                        empreendimento={this.state.currentShowing}
                        showEmprendimentoCard={this.state.panel_empreendimento_visible}
                        showModalEmpreendimento={this.state.modal_empreendimento_visible}
                        closeModalEmpreendimento={this.closeModalEmpreendimento}
                        handleHideClicked={this.handleHideClicked}
                        overlays={this.state.overlays}
                        togglePainelEmpreendimento={this.togglePainelEmpreendimento}
                        loading_empreendimento={this.state.loading_empreendimento}
                        empreendimentos={this.state.empreendimentos}
                        ranges={this.state.ranges}
                        replaceMarkers={this.replaceMarkers}
                        addRange={this.addRange}
                        updateRange={this.updateRange}
                        removeRange={this.removeRange}
                        addHeatMap={this.addHeatMap}
                        setHeatMapWeightType={this.setHeatMapWeightType}
                        show_polos_geradores={this.state.show_polos_geradores}
                        setPolosGeradoresCurrentShowing={this.setPolosGeradoresCurrentShowing}
                        cidades={this.state.cidade}
                        estados={this.state.estado}
                        editShapeName={this.editShapeName}
                        showIbgeInfo={this.showIbgeInfo}
                        showRenda={this.state.showRenda}
                        rendasPorArea={this.state.rendas_por_area}
                        originalState={this.state}
                    />)}
                <div id="map-container">
                    <MapWithADrawingManager
                        setDrawing={this.setDrawing}
                        setMarkersClickable={this.setMarkersClickable}
                        onMarkerComplete={this.onMarkerComplete}
                        currentPosition={this.state.currentPosition}
                        onPolygonComplete={this.onPolygonComplete}
                        onCircleComplete={this.onCircleComplete}
                        empreendimentos={this.state.empreendimentos}
                        onRectangleComplete={this.onRectangleComplete}
                        onMarkerClick={this.onMarkerClick}
                        onRevendaMarkerClick={this.onRevendaMarkerClick}
                        manualCircles={this.state.manualCircles}
                        raio={this.state.raio}
                        zoom={this.state.zoom}
                        setLocation={this.setLocation}
                        pontos={this.state.pontos}
                        getColor={this.getColor}
                        fillColor={this.state.fillColor}
                        selectedIcon={this.state.selectedIcon}
                        showInfoWindow={this.showInfoWindow}
                        handleShowInfoWindow={this.handleShowInfoWindow}
                        handleHideInfoWindow={this.handleHideInfoWindow}
                        showKMl={this.state.showKMl}
                        kml_layers={this.state.kmls_to_show}
                        showMarkers={this.state.showMarkers}
                        show_polos_geradores={this.state.show_polos_geradores}
                        showResaleMarkers={this.state.showResaleMarkers}
                        showResaleOrLocationMarkers={this.state.showResaleOrLocationMarkers}
                        showLocationMarkers={this.state.showLocationMarkers}
                        polos_geradores={this.state.polos_geradores}
                        revendaLocacao={this.state.revendaLocacao}
                        editShapeName={this.editShapeName}
                        use_cluster={this.state.use_cluster}
                        currentShowing={this.state.currentShowing}
                        onCenterMarkClick={this.showModalDeslocamento}
                        hide_search_box={this.state.hide_search_box}

                    />

                </div>
                <MouseTooltip
                    visible={this.state.showTooltip}
                    offsetX={15}
                    offsetY={10}
                >
                    <span
                        style={{
                            fontWeight: "bold",
                            padding: "10px",
                            backgroundColor: "green",
                            color: "#ffffff",
                            borderRadius: "5pu",
                        }}
                    >
                        {Number(this.state.radiusChanging).toFixed(2)}{" "}
                        metros
                    </span>
                </MouseTooltip>
            </div>
            {this.state.showRenda && <RendaIbgeLegend />}
        </>);
    }

    //verifica se tem formas desenhadas no mapa
    thereAreDrownShapes() {
        let countFormas = this.state.polygons.length + this.state.circles.length;

        if (countFormas === 0) {
            return false;
        }

        let count = 0;

        this.state.circles.forEach((circle) => {
            if (circle.getMap() !== null) {
                count++;
            }
        });

        this.state.polygons.forEach((polygon) => {
            if (polygon.getMap() !== null) {
                count++;
            }
        });

        return count > 0;
    }


    async getKmlBairros(cidade, uf) {
        try {
            //verifica se o kml da cidade já existe no this.state.kml_bairros
            let kmlCidade = this.state.kml_bairros.find(kml => kml.cidade === cidade && kml.uf === uf);

            if (kmlCidade) {
                return;
            }

            let response = await axios.get(route('bairros.kml', { cidade: cidade, estado: uf }));
            let kmlBairros = this.state.kml_bairros;
            kmlBairros[cidade] = response.data.kml;

            if (response.data.kml !== null && response.data.kml !== undefined && response.data.kml !== '') {
                this.setState({
                    ...this.state, kml_bairros: [...this.state.kml_bairros, {
                        cidade: cidade, kml: response.data.kml, uf: uf
                    }]
                })

                //await axios.get( response.data.kml );
            }

        } catch (e) {
            console.log(e)
        }
    }

    //limpa kmls de bairros
    cleanKmlLayers() {
        this.state.kml_layers.forEach((kml_layer) => {
            try {
                if (kml_layer.setMap !== undefined) {
                    kml_layer.setMap(null);
                }
            } catch (error) {
                console.log(error);
            }
        });

        this.setState({
            ...this.state, kml_layers: [], kmls_to_show: []
        })
    }

    getGradientConfig() {
        return [
            "rgba(0, 255, 255, 0)",
            "rgba(0, 255, 255, 1)",
            "rgba(0, 191, 255, 1)",
            "rgba(0, 127, 255, 1)",
            "rgba(0, 63, 255, 1)",
            "rgba(0, 0, 255, 1)",
            "rgba(0, 0, 223, 1)",
            "rgba(0, 0, 191, 1)",
            "rgba(0, 0, 159, 1)",
            "rgba(0, 0, 127, 1)",
            "rgba(63, 0, 91, 1)",
            "rgba(127, 0, 63, 1)",
            "rgba(191, 0, 31, 1)",
            "rgba(255, 0, 0, 1)",
        ];
    }

    openModalPolosGeradores = async () => {
        this.setState({
            ...this.state, show_modal_polos_geradores: true
        })
    }

    closeModalPolosGeradores = async () => {
        this.setState({
            ...this.state, show_modal_polos_geradores: false
        })
    }

    setShowPolosGeradores = async (show_polos_geradores) => {
        if (show_polos_geradores == true) {
            this.setState({ showMarkers: false });

        }
        this.setState({ show_polos_geradores: show_polos_geradores })
    }

    setShowMarkers = async (showMarkers) => {
        this.setState({ showMarkers: showMarkers })
    }

    setShowResaleMarkers = async (showResaleMarkers) => {
        let tipo_negocio = []

        if (showResaleMarkers) {
            tipo_negocio.push({ value: "Venda", label: "Revenda" });
        }

        this.state.tipo_negocio.forEach((tipo) => {
            if (tipo.value != tipo_negocio[0]?.value && tipo.value != "Venda") {
                tipo_negocio.push(tipo)
            }


        })

        await this.setState({
            ...this.state,
            showResaleMarkers: showResaleMarkers,
            showResaleOrLocationMarkers: showResaleMarkers,
            tipo_negocio: tipo_negocio
        })

    }

    setShowLocationMarkers = async (showLocationMarkers) => {

        let tipo_negocio = [];

        if (showLocationMarkers) {
            tipo_negocio.push({ value: "Aluguel", label: "Locação" });
        }
        this.state.tipo_negocio.forEach((tipo) => {
            if (!tipo.value != tipo_negocio[0]?.value && tipo.value != "Aluguel") {
                tipo_negocio.push(tipo)
            }


        })

        await this.setState({
            ...this.state,
            showLocationMarkers: showLocationMarkers,
            showResaleOrLocationMarkers: showLocationMarkers,
            tipo_negocio: tipo_negocio
        })
    }


    setPolosGeradoresTypes = async (e) => {
        await this.setState({
            ...this.state,
            polos_geradores_types_selected: e.value
        })
    }

    getPolosGeradoresTypesAsArray = () => {
        return this.state.polos_geradores_types_selected;
    }

    removePolosGeradoresTypeSelectedAndReloadEmpreendimentos = async (index) => {
        let polos_geradores_types_selected = this.state.polos_geradores_types_selected;

        polos_geradores_types_selected.splice(index, 1);

        await this.setState({
            ...this.state,
            polos_geradores_types_selected: [...polos_geradores_types_selected]
        });

        await this.reloadEmpreendimentos();
    }

    comparaPolosOnArea = async () => {

        let payload = [];

        this.state.overlays.forEach((area) => {

            if (area.polos_geradores_cache_key === '' || area.polos_geradores_cache_key === undefined) {
                return;
            }

            let areaName = '';

            if (area.name !== undefined) {
                areaName = area.name;
            }

            payload.push({
                cache_key: area.polos_geradores_cache_key, area: area.type.split(' ')[0] + ' ' + areaName
            });

        });


    }

    setBuscaPorEstado = (e) => {
        this.setState({
            ...this.state, busca_por_estado: e.target.checked
        })
    }


    removeIbgeDataLayer = async () => {

        if (!this.state.ibgeDataLayer) {
            return;
        }

        await this.removeZoneamentoDataLayer();


        this.state.ibgeDataLayer?.setMap(null);

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        for (let i = 0; i < this.state.ibgeDataLayer; i++) {
            map.data.remove(this.state.ibgeDataLayer[i]);
        }

        window.ibge_layer = null;

        this.setState({
            ...this.state,
            ibgeDataLayer: null,
            ibge_info: null,
            showRenda: false,
        });

    }


    removeZoneamentoDataLayer = async () => {

        if (!this.state.zoneamentoDataLayer) {
            return;
        }

        await this.removeIbgeDataLayer();

        this.state.zoneamentoDataLayer?.setMap(null);

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        for (let i = 0; i < this.state.zoneamentoDataLayer; i++) {
            map.data.remove(this.state.zoneamentoDataLayer[i]);
        }

        window.zoneamentoDataLayer = null;

        this.setState({
            ...this.state,
            zoneamentoDataLayer: null,
        });

    }

    toggleIbgeDataLayerVisibility = async () => {

        if (!this.state.ibgeDataLayer) {
            return;
        }

        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        if (this.state.ibgeDataLayer?.getMap() === null) {
            this.state.ibgeDataLayer?.setMap(map);

            this.setState({
                ...this.state,
            });


        } else {
            this.state.ibgeDataLayer?.setMap(null);

            this.setState({
                ...this.state,
            });
        }

    }

    showModalDeslocamento = async (markerPosition) => {
        this.setState({
            ...this.state,
            show_modal_raio_de_deslocamento: true,
            marker_deslocamento_position: markerPosition
        });

        $("#btn-results").click();
    }

    closeModalDeslocamento = async () => {
        this.setState({
            ...this.state,
            show_modal_raio_de_deslocamento: false
        });
    }

    toogleOverlayVisibility = async (overlay) => {

        if (overlay.getMap() == null) {
            overlay.setMap(window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);
        } else {
            overlay.setMap(null);
        }

        await this.reloadEmpreendimentos();
    }

    getPolygonBounds = async (polygon) => {

        let bounds = new google.maps.LatLngBounds();
        polygon.getPaths().forEach(function (path) {
            path.forEach(function (latlng) {
                bounds.extend(latlng);
            });
        });

        return bounds;
    }

    fitBounds = (bounds) => {
        let map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        map.fitBounds(bounds);

        if (this.state.regiao.length > 0) {
            map.setZoom(10);
            const firstBuildingLocation = new google.maps.LatLng(
                this.state.empreendimentos[0].location.coordinates[1], // Latitude
                this.state.empreendimentos[0].location.coordinates[0]  // Longitude
            );

            // Centraliza o mapa no primeiro empreendimento
            map.setCenter(firstBuildingLocation);
        }
    }

    handleShareUsersChanged = async (share_users) => {
        this.setState({
            ...this.state, project_share_users: share_users
        });
    }

    toggleShowZoneamento = async () => {

        let current = this.state.show_zoneamento;

        await this.setState({
            ...this.state,
            show_zoneamento: !this.state.show_zoneamento,
        })

        if (current) {
            await this.removeZoneamentoDataLayer();
            return;
        }

        await this.showZoneamentoLayer();
    }

}

export default DefaultMap;
